// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAgIiBmaWxsPSJub25lIiBzdHJva2U9IiMxZjI5Mzc1MCIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIiAvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root, [data-theme] {
  color: hsl(var(--heroui-foreground));
  background-color: hsl(var(--heroui-background));
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-20 {
  bottom: -5rem;
}
.-bottom-4 {
  bottom: -1rem;
}
.-bottom-40 {
  bottom: -10rem;
}
.-bottom-6 {
  bottom: -1.5rem;
}
.-left-20 {
  left: -5rem;
}
.-left-4 {
  left: -1rem;
}
.-left-40 {
  left: -10rem;
}
.-left-6 {
  left: -1.5rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-20 {
  right: -5rem;
}
.-right-4 {
  right: -1rem;
}
.-right-40 {
  right: -10rem;
}
.-right-6 {
  right: -1.5rem;
}
.-right-px {
  right: -1px;
}
.-top-2 {
  top: -0.5rem;
}
.-top-20 {
  top: -5rem;
}
.-top-40 {
  top: -10rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-px {
  top: -1px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1\\/4 {
  bottom: 25%;
}
.bottom-12 {
  bottom: 3rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-\\[10\\%\\] {
  bottom: 10%;
}
.bottom-\\[5\\%\\] {
  bottom: 5%;
}
.end-1 {
  inset-inline-end: 0.25rem;
}
.end-1\\.5 {
  inset-inline-end: 0.375rem;
}
.end-3 {
  inset-inline-end: 0.75rem;
}
.end-auto {
  inset-inline-end: auto;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-20 {
  left: 5rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[10\\%\\] {
  left: 10%;
}
.left-\\[5\\%\\] {
  left: 5%;
}
.left-\\[calc\\(37\\.5\\%\\)\\] {
  left: calc(37.5%);
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-20 {
  right: 5rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[10\\%\\] {
  right: 10%;
}
.right-\\[5\\%\\] {
  right: 5%;
}
.start-0 {
  inset-inline-start: 0px;
}
.start-1\\.5 {
  inset-inline-start: 0.375rem;
}
.start-2 {
  inset-inline-start: 0.5rem;
}
.start-3 {
  inset-inline-start: 0.75rem;
}
.start-auto {
  inset-inline-start: auto;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/4 {
  top: 25%;
}
.top-2 {
  top: 0.5rem;
}
.top-20 {
  top: 5rem;
}
.top-\\[10\\%\\] {
  top: 10%;
}
.top-\\[5\\%\\] {
  top: 5%;
}
.top-\\[calc\\(100\\%_\\+_2px\\)\\] {
  top: calc(100% + 2px);
}
.top-\\[calc\\(46\\%\\)\\] {
  top: calc(46%);
}
.top-\\[var\\(--navbar-height\\)\\] {
  top: var(--navbar-height);
}
.-z-10 {
  z-index: -10;
}
.-z-30 {
  z-index: -30;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.-m-2 {
  margin: -0.5rem;
}
.-m-2\\.5 {
  margin: -0.625rem;
}
.m-0 {
  margin: 0px;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\] {
  margin-left: calc((1.25rem - 0.25rem) / 2);
  margin-right: calc((1.25rem - 0.25rem) / 2);
}
.mx-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\] {
  margin-left: calc((1.5rem - 0.75rem) / 2);
  margin-right: calc((1.5rem - 0.75rem) / 2);
}
.mx-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\] {
  margin-left: calc((1.75rem - 1.25rem) / 2);
  margin-right: calc((1.75rem - 1.25rem) / 2);
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\] {
  margin-top: calc((1.25rem - 0.25rem) / 2);
  margin-bottom: calc((1.25rem - 0.25rem) / 2);
}
.my-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\] {
  margin-top: calc((1.5rem - 0.75rem) / 2);
  margin-bottom: calc((1.5rem - 0.75rem) / 2);
}
.my-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\] {
  margin-top: calc((1.75rem - 1.25rem) / 2);
  margin-bottom: calc((1.75rem - 1.25rem) / 2);
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.-ms-2 {
  margin-inline-start: -0.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-px {
  margin-bottom: 1px;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-8 {
  margin-right: 2rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.box-border {
  box-sizing: border-box;
}
.box-content {
  box-sizing: content-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.size-1 {
  width: 0.25rem;
  height: 0.25rem;
}
.size-1\\.5 {
  width: 0.375rem;
  height: 0.375rem;
}
.size-2 {
  width: 0.5rem;
  height: 0.5rem;
}
.\\!h-auto {
  height: auto !important;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[--visual-viewport-height\\] {
  height: var(--visual-viewport-height);
}
.h-\\[100dvh\\] {
  height: 100dvh;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[8\\%\\] {
  height: 8%;
}
.h-\\[calc\\(100dvh_-_var\\(--navbar-height\\)\\)\\] {
  height: calc(100dvh - var(--navbar-height));
}
.h-\\[var\\(--navbar-height\\)\\] {
  height: var(--navbar-height);
}
.h-\\[var\\(--picker-height\\)\\] {
  height: var(--picker-height);
}
.h-auto {
  height: auto;
}
.h-divider {
  height: var(--heroui-divider-weight);
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-min {
  height: min-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[20rem\\] {
  max-height: 20rem;
}
.max-h-\\[24rem\\] {
  max-height: 24rem;
}
.max-h-\\[28rem\\] {
  max-height: 28rem;
}
.max-h-\\[32rem\\] {
  max-height: 32rem;
}
.max-h-\\[36rem\\] {
  max-height: 36rem;
}
.max-h-\\[42rem\\] {
  max-height: 42rem;
}
.max-h-\\[48rem\\] {
  max-height: 48rem;
}
.max-h-\\[56rem\\] {
  max-height: 56rem;
}
.max-h-\\[64rem\\] {
  max-height: 64rem;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(100\\%_-_8rem\\)\\] {
  max-height: calc(100% - 8rem);
}
.max-h-\\[none\\] {
  max-height: none;
}
.max-h-full {
  max-height: 100%;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-14 {
  min-height: 3.5rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-3 {
  min-height: 0.75rem;
}
.min-h-3\\.5 {
  min-height: 0.875rem;
}
.min-h-4 {
  min-height: 1rem;
}
.min-h-5 {
  min-height: 1.25rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-7 {
  min-height: 1.75rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-\\[100dvh\\] {
  min-height: 100dvh;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[calc\\(100\\%_-_16px\\)\\] {
  width: calc(100% - 16px);
}
.w-\\[calc\\(100\\%_-_theme\\(spacing\\.6\\)\\)\\] {
  width: calc(100% - 1.5rem);
}
.w-\\[calc\\(var\\(--visible-months\\)_\\*_var\\(--calendar-width\\)\\)\\] {
  width: calc(var(--visible-months) * var(--calendar-width));
}
.w-auto {
  width: auto;
}
.w-divider {
  width: var(--heroui-divider-weight);
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-12 {
  min-width: 3rem;
}
.min-w-16 {
  min-width: 4rem;
}
.min-w-20 {
  min-width: 5rem;
}
.min-w-24 {
  min-width: 6rem;
}
.min-w-3 {
  min-width: 0.75rem;
}
.min-w-3\\.5 {
  min-width: 0.875rem;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-6 {
  min-width: 1.5rem;
}
.min-w-7 {
  min-width: 1.75rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.min-w-min {
  min-width: min-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-\\[1024px\\] {
  max-width: 1024px;
}
.max-w-\\[1280px\\] {
  max-width: 1280px;
}
.max-w-\\[1536px\\] {
  max-width: 1536px;
}
.max-w-\\[270px\\] {
  max-width: 270px;
}
.max-w-\\[640px\\] {
  max-width: 640px;
}
.max-w-\\[768px\\] {
  max-width: 768px;
}
.max-w-\\[none\\] {
  max-width: none;
}
.max-w-fit {
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-initial {
  flex: 0 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.basis-0 {
  flex-basis: 0px;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-center {
  transform-origin: center;
}
.origin-left {
  transform-origin: left;
}
.origin-right {
  transform-origin: right;
}
.origin-top {
  transform-origin: top;
}
.origin-top-left {
  transform-origin: top left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3\\/4 {
  --tw-translate-y: 75%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes appearance-in {

  0% {
    opacity: 0;
    transform: translateZ(0)  scale(0.95);
  }

  60% {
    opacity: 0.75;
    backface-visibility: hidden;
    webkit-font-smoothing: antialiased;
    transform: translateZ(0) scale(1.05);
  }

  100% {
    opacity: 1;
    transform: translateZ(0) scale(1);
  }
}
.animate-\\[appearance-in_1s_infinite\\] {
  animation: appearance-in 1s infinite;
}
@keyframes blink {

  0% {
    opacity: 0.2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
.animate-blink {
  animation: blink 1.4s infinite both;
}
@keyframes drip-expand {

  0% {
    opacity: 0.2;
    transform: scale(0);
  }

  100% {
    opacity: 0;
    transform: scale(2);
  }
}
.animate-drip-expand {
  animation: drip-expand 420ms linear;
}
@keyframes fade-out {

  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.15;
  }
}
.animate-fade-out {
  animation: fade-out 1.2s linear 0s infinite normal none running;
}
@keyframes indeterminate-bar {

  0% {
    transform: translateX(-50%) scaleX(0.2);
  }

  100% {
    transform: translateX(100%) scaleX(1);
  }
}
.animate-indeterminate-bar {
  animation: indeterminate-bar 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite normal none running;
}
.animate-none {
  animation: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spinner-spin {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.animate-spinner-ease-spin {
  animation: spinner-spin 0.8s ease infinite;
}
@keyframes spinner-spin {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.animate-spinner-linear-spin {
  animation: spinner-spin 0.8s linear infinite;
}
@keyframes sway {

  0% {
    transform: translate(0px, 0px);
  }

  50% {
    transform: translate(0px, -150%);
  }

  100% {
    transform: translate(0px, 0px);
  }
}
.animate-sway {
  animation: sway 750ms ease infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.scroll-py-6 {
  scroll-padding-top: 1.5rem;
  scroll-padding-bottom: 1.5rem;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-content-center {
  place-content: center;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.\\!gap-0 {
  gap: 0px !important;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-0\\.5 {
  column-gap: 0.125rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.space-x-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-clip {
  overflow: clip;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[calc\\(theme\\(borderRadius\\.large\\)\\/1\\.5\\)\\] {
  border-radius: calc(var(--heroui-radius-large) / 1.5);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) * 0.5);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) * 0.6);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) * 0.7);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\/2\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) / 2);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.small\\)\\/2\\)\\] {
  border-radius: calc(var(--heroui-radius-small) / 2);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-large {
  border-radius: var(--heroui-radius-large);
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-medium {
  border-radius: var(--heroui-radius-medium);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-small {
  border-radius: var(--heroui-radius-small);
}
.\\!rounded-e-none {
  border-start-end-radius: 0px !important;
  border-end-end-radius: 0px !important;
}
.\\!rounded-s-none {
  border-start-start-radius: 0px !important;
  border-end-start-radius: 0px !important;
}
.rounded-b-large {
  border-bottom-right-radius: var(--heroui-radius-large);
  border-bottom-left-radius: var(--heroui-radius-large);
}
.rounded-b-medium {
  border-bottom-right-radius: var(--heroui-radius-medium);
  border-bottom-left-radius: var(--heroui-radius-medium);
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-small {
  border-bottom-right-radius: var(--heroui-radius-small);
  border-bottom-left-radius: var(--heroui-radius-small);
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-large {
  border-top-left-radius: var(--heroui-radius-large);
  border-top-right-radius: var(--heroui-radius-large);
}
.rounded-t-medium {
  border-top-left-radius: var(--heroui-radius-medium);
  border-top-right-radius: var(--heroui-radius-medium);
}
.rounded-t-none {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-small {
  border-top-left-radius: var(--heroui-radius-small);
  border-top-right-radius: var(--heroui-radius-small);
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-1 {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-3 {
  border-width: 3px;
}
.border-medium {
  border-width: var(--heroui-border-width-medium);
}
.border-small {
  border-width: var(--heroui-border-width-small);
}
.border-x-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\] {
  border-left-width: calc(1.25rem / 2);
  border-right-width: calc(1.25rem / 2);
}
.border-x-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\] {
  border-left-width: calc(1.5rem / 2);
  border-right-width: calc(1.5rem / 2);
}
.border-x-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\] {
  border-left-width: calc(1.75rem / 2);
  border-right-width: calc(1.75rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\] {
  border-top-width: calc(1.25rem / 2);
  border-bottom-width: calc(1.25rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\] {
  border-top-width: calc(1.5rem / 2);
  border-bottom-width: calc(1.5rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\] {
  border-top-width: calc(1.75rem / 2);
  border-bottom-width: calc(1.75rem / 2);
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-medium {
  border-bottom-width: var(--heroui-border-width-medium);
}
.border-t {
  border-top-width: 1px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.\\!border-danger {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity))) !important;
}
.border-background {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-border-opacity)));
}
.border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}
.border-danger-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-border-opacity)));
}
.border-danger-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-200) / var(--heroui-danger-200-opacity, var(--tw-border-opacity)));
}
.border-danger-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-400) / var(--heroui-danger-400-opacity, var(--tw-border-opacity)));
}
.border-default {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-border-opacity)));
}
.border-default-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-border-opacity)));
}
.border-default-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-border-opacity)));
}
.border-default-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-border-opacity)));
}
.border-default-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}
.border-divider {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-divider) / var(--heroui-divider-opacity, var(--tw-border-opacity)));
}
.border-divider\\/10 {
  border-color: hsl(var(--heroui-divider) / 0.1);
}
.border-divider\\/30 {
  border-color: hsl(var(--heroui-divider) / 0.3);
}
.border-foreground {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-border-opacity)));
}
.border-foreground-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-foreground-400) / var(--heroui-foreground-400-opacity, var(--tw-border-opacity)));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}
.border-primary-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-100) / var(--heroui-primary-100-opacity, var(--tw-border-opacity)));
}
.border-primary-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-200) / var(--heroui-primary-200-opacity, var(--tw-border-opacity)));
}
.border-primary-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-400) / var(--heroui-primary-400-opacity, var(--tw-border-opacity)));
}
.border-primary\\/10 {
  border-color: hsl(var(--heroui-primary) / 0.1);
}
.border-primary\\/20 {
  border-color: hsl(var(--heroui-primary) / 0.2);
}
.border-primary\\/50 {
  border-color: hsl(var(--heroui-primary) / 0.5);
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}
.border-secondary-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary-100) / var(--heroui-secondary-100-opacity, var(--tw-border-opacity)));
}
.border-secondary-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary-200) / var(--heroui-secondary-200-opacity, var(--tw-border-opacity)));
}
.border-secondary-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary-400) / var(--heroui-secondary-400-opacity, var(--tw-border-opacity)));
}
.border-secondary\\/20 {
  border-color: hsl(var(--heroui-secondary) / 0.2);
}
.border-success {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}
.border-success-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-100) / var(--heroui-success-100-opacity, var(--tw-border-opacity)));
}
.border-success-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-200) / var(--heroui-success-200-opacity, var(--tw-border-opacity)));
}
.border-success-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-300) / var(--heroui-success-300-opacity, var(--tw-border-opacity)));
}
.border-success-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-400) / var(--heroui-success-400-opacity, var(--tw-border-opacity)));
}
.border-success\\/20 {
  border-color: hsl(var(--heroui-success) / 0.2);
}
.border-transparent {
  border-color: transparent;
}
.border-warning {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}
.border-warning-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-border-opacity)));
}
.border-warning-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-200) / var(--heroui-warning-200-opacity, var(--tw-border-opacity)));
}
.border-warning-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-300) / var(--heroui-warning-300-opacity, var(--tw-border-opacity)));
}
.border-warning-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-400) / var(--heroui-warning-400-opacity, var(--tw-border-opacity)));
}
.border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.border-y-transparent {
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.border-b-current {
  border-bottom-color: currentColor;
}
.border-b-danger {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}
.border-b-default {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-border-opacity)));
}
.border-b-foreground {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-border-opacity)));
}
.border-b-primary {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}
.border-b-secondary {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}
.border-b-success {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}
.border-b-warning {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}
.border-b-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-s-danger {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}
.border-s-foreground {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-border-opacity)));
}
.border-s-primary {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}
.border-s-secondary {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}
.border-s-success {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}
.border-s-warning {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-danger-50 {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity))) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-bg-opacity)));
}
.bg-background\\/10 {
  background-color: hsl(var(--heroui-background) / 0.1);
}
.bg-background\\/70 {
  background-color: hsl(var(--heroui-background) / 0.7);
}
.bg-background\\/80 {
  background-color: hsl(var(--heroui-background) / 0.8);
}
.bg-background\\/90 {
  background-color: hsl(var(--heroui-background) / 0.9);
}
.bg-background\\/95 {
  background-color: hsl(var(--heroui-background) / 0.95);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-content1 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content1) / var(--heroui-content1-opacity, var(--tw-bg-opacity)));
}
.bg-content3 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content3) / var(--heroui-content3-opacity, var(--tw-bg-opacity)));
}
.bg-current {
  background-color: currentColor;
}
.bg-danger {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}
.bg-danger-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-bg-opacity)));
}
.bg-danger-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-400) / var(--heroui-danger-400-opacity, var(--tw-bg-opacity)));
}
.bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}
.bg-danger\\/20 {
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.bg-default {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity)));
}
.bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}
.bg-default-200 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}
.bg-default-300\\/50 {
  background-color: hsl(var(--heroui-default-300) / 0.5);
}
.bg-default-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-bg-opacity)));
}
.bg-default-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-50) / var(--heroui-default-50-opacity, var(--tw-bg-opacity)));
}
.bg-default-500 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-500) / var(--heroui-default-500-opacity, var(--tw-bg-opacity)));
}
.bg-default-800 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-800) / var(--heroui-default-800-opacity, var(--tw-bg-opacity)));
}
.bg-default\\/40 {
  background-color: hsl(var(--heroui-default) / 0.4);
}
.bg-divider {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-divider) / var(--heroui-divider-opacity, var(--tw-bg-opacity)));
}
.bg-foreground {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}
.bg-foreground-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground-100) / var(--heroui-foreground-100-opacity, var(--tw-bg-opacity)));
}
.bg-foreground-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground-400) / var(--heroui-foreground-400-opacity, var(--tw-bg-opacity)));
}
.bg-foreground\\/10 {
  background-color: hsl(var(--heroui-foreground) / 0.1);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-overlay\\/30 {
  background-color: hsl(var(--heroui-overlay) / 0.3);
}
.bg-overlay\\/50 {
  background-color: hsl(var(--heroui-overlay) / 0.5);
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-100) / var(--heroui-primary-100-opacity, var(--tw-bg-opacity)));
}
.bg-primary-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-400) / var(--heroui-primary-400-opacity, var(--tw-bg-opacity)));
}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}
.bg-primary\\/10 {
  background-color: hsl(var(--heroui-primary) / 0.1);
}
.bg-primary\\/20 {
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.bg-primary\\/5 {
  background-color: hsl(var(--heroui-primary) / 0.05);
}
.bg-primary\\/70 {
  background-color: hsl(var(--heroui-primary) / 0.7);
}
.bg-primary\\/90 {
  background-color: hsl(var(--heroui-primary) / 0.9);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}
.bg-secondary-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-100) / var(--heroui-secondary-100-opacity, var(--tw-bg-opacity)));
}
.bg-secondary-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-400) / var(--heroui-secondary-400-opacity, var(--tw-bg-opacity)));
}
.bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.bg-secondary\\/10 {
  background-color: hsl(var(--heroui-secondary) / 0.1);
}
.bg-secondary\\/20 {
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.bg-secondary\\/5 {
  background-color: hsl(var(--heroui-secondary) / 0.05);
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}
.bg-success-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--heroui-success-100-opacity, var(--tw-bg-opacity)));
}
.bg-success-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-400) / var(--heroui-success-400-opacity, var(--tw-bg-opacity)));
}
.bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}
.bg-success\\/20 {
  background-color: hsl(var(--heroui-success) / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}
.bg-warning-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-bg-opacity)));
}
.bg-warning-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-400) / var(--heroui-warning-400-opacity, var(--tw-bg-opacity)));
}
.bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}
.bg-warning\\/20 {
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\;base64\\2c PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI\\+PGRlZnM\\+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI\\+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAgIiBmaWxsPSJub25lIiBzdHJva2U9IiMxZjI5Mzc1MCIgc3Ryb2tlLXdpZHRoPSIxIi8\\+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIiAvPjwvc3ZnPg\\=\\=\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-stripe-gradient-danger {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-danger-200)) 25%,  hsl(var(--heroui-danger)) 25%,  hsl(var(--heroui-danger)) 50%,  hsl(var(--heroui-danger-200)) 50%,  hsl(var(--heroui-danger-200)) 75%,  hsl(var(--heroui-danger)) 75%,  hsl(var(--heroui-danger)));
}
.bg-stripe-gradient-default {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-default-200)) 25%,  hsl(var(--heroui-default-400)) 25%,  hsl(var(--heroui-default-400)) 50%,  hsl(var(--heroui-default-200)) 50%,  hsl(var(--heroui-default-200)) 75%,  hsl(var(--heroui-default-400)) 75%,  hsl(var(--heroui-default-400)));
}
.bg-stripe-gradient-primary {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-primary-200)) 25%,  hsl(var(--heroui-primary)) 25%,  hsl(var(--heroui-primary)) 50%,  hsl(var(--heroui-primary-200)) 50%,  hsl(var(--heroui-primary-200)) 75%,  hsl(var(--heroui-primary)) 75%,  hsl(var(--heroui-primary)));
}
.bg-stripe-gradient-secondary {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-secondary-200)) 25%,  hsl(var(--heroui-secondary)) 25%,  hsl(var(--heroui-secondary)) 50%,  hsl(var(--heroui-secondary-200)) 50%,  hsl(var(--heroui-secondary-200)) 75%,  hsl(var(--heroui-secondary)) 75%,  hsl(var(--heroui-secondary)));
}
.bg-stripe-gradient-success {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-success-200)) 25%,  hsl(var(--heroui-success)) 25%,  hsl(var(--heroui-success)) 50%,  hsl(var(--heroui-success-200)) 50%,  hsl(var(--heroui-success-200)) 75%,  hsl(var(--heroui-success)) 75%,  hsl(var(--heroui-success)));
}
.bg-stripe-gradient-warning {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-warning-200)) 25%,  hsl(var(--heroui-warning)) 25%,  hsl(var(--heroui-warning)) 50%,  hsl(var(--heroui-warning-200)) 50%,  hsl(var(--heroui-warning-200)) 75%,  hsl(var(--heroui-warning)) 75%,  hsl(var(--heroui-warning)));
}
.from-background {
  --tw-gradient-from: hsl(var(--heroui-background) / var(--heroui-background-opacity, 1)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-background) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70 {
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary {
  --tw-gradient-from: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, 1)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/10 {
  --tw-gradient-from: hsl(var(--heroui-primary) / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/40 {
  --tw-gradient-from: hsl(var(--heroui-primary) / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/5 {
  --tw-gradient-from: hsl(var(--heroui-primary) / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-secondary {
  --tw-gradient-from: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, 1)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-secondary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-secondary\\/10 {
  --tw-gradient-from: hsl(var(--heroui-secondary) / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-secondary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-success\\/10 {
  --tw-gradient-from: hsl(var(--heroui-success) / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--heroui-success) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-background {
  --tw-gradient-to: hsl(var(--heroui-background) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-background) / var(--heroui-background-opacity, 1)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary {
  --tw-gradient-to: hsl(var(--heroui-primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-primary) / var(--heroui-primary-opacity, 1)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/30 {
  --tw-gradient-to: hsl(var(--heroui-primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-primary) / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-background\\/80 {
  --tw-gradient-to: hsl(var(--heroui-background) / 0.8) var(--tw-gradient-to-position);
}
.to-current {
  --tw-gradient-to: currentColor var(--tw-gradient-to-position);
}
.to-danger {
  --tw-gradient-to: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, 1)) var(--tw-gradient-to-position);
}
.to-default {
  --tw-gradient-to: hsl(var(--heroui-default) / var(--heroui-default-opacity, 1)) var(--tw-gradient-to-position);
}
.to-primary {
  --tw-gradient-to: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, 1)) var(--tw-gradient-to-position);
}
.to-primary\\/5 {
  --tw-gradient-to: hsl(var(--heroui-primary) / 0.05) var(--tw-gradient-to-position);
}
.to-secondary {
  --tw-gradient-to: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, 1)) var(--tw-gradient-to-position);
}
.to-secondary\\/10 {
  --tw-gradient-to: hsl(var(--heroui-secondary) / 0.1) var(--tw-gradient-to-position);
}
.to-secondary\\/40 {
  --tw-gradient-to: hsl(var(--heroui-secondary) / 0.4) var(--tw-gradient-to-position);
}
.to-secondary\\/5 {
  --tw-gradient-to: hsl(var(--heroui-secondary) / 0.05) var(--tw-gradient-to-position);
}
.to-success {
  --tw-gradient-to: hsl(var(--heroui-success) / var(--heroui-success-opacity, 1)) var(--tw-gradient-to-position);
}
.to-success\\/5 {
  --tw-gradient-to: hsl(var(--heroui-success) / 0.05) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-warning {
  --tw-gradient-to: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, 1)) var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-stripe-size {
  background-size: 1.25rem 1.25rem;
}
.bg-clip-text {
  background-clip: text;
}
.fill-current {
  fill: currentColor;
}
.stroke-current {
  stroke: currentColor;
}
.stroke-default-300\\/50 {
  stroke: hsl(var(--heroui-default-300) / 0.5);
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.\\!px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pb-0 {
  padding-bottom: 0px !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pe-2 {
  padding-inline-end: 0.5rem;
}
.pe-6 {
  padding-inline-end: 1.5rem;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-\\[1px\\] {
  padding-left: 1px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-9xl {
  font-size: 8rem;
  line-height: 1;
}
.text-\\[0\\.55rem\\] {
  font-size: 0.55rem;
}
.text-\\[0\\.5rem\\] {
  font-size: 0.5rem;
}
.text-\\[0\\.6rem\\] {
  font-size: 0.6rem;
}
.text-\\[100\\%\\] {
  font-size: 100%;
}
.text-large {
  font-size: var(--heroui-font-size-large);
  line-height: var(--heroui-line-height-large);
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-medium {
  font-size: var(--heroui-font-size-medium);
  line-height: var(--heroui-line-height-medium);
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-small {
  font-size: var(--heroui-font-size-small);
  line-height: var(--heroui-line-height-small);
}
.text-tiny {
  font-size: var(--heroui-font-size-tiny);
  line-height: var(--heroui-line-height-tiny);
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-extralight {
  font-weight: 200;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[1\\.15\\] {
  line-height: 1.15;
}
.leading-\\[32px\\] {
  line-height: 32px;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-danger {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity))) !important;
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-background {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-text-opacity)));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-current {
  color: currentColor;
}
.text-danger {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}
.text-danger-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-300) / var(--heroui-danger-300-opacity, var(--tw-text-opacity)));
}
.text-danger-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-400) / var(--heroui-danger-400-opacity, var(--tw-text-opacity)));
}
.text-danger-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}
.text-danger-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-600) / var(--heroui-danger-600-opacity, var(--tw-text-opacity)));
}
.text-danger-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.text-danger\\/80 {
  color: hsl(var(--heroui-danger) / 0.8);
}
.text-default {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-text-opacity)));
}
.text-default-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-text-opacity)));
}
.text-default-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-500) / var(--heroui-default-500-opacity, var(--tw-text-opacity)));
}
.text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--heroui-default-600-opacity, var(--tw-text-opacity)));
}
.text-default-700 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-700) / var(--heroui-default-700-opacity, var(--tw-text-opacity)));
}
.text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}
.text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}
.text-foreground-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-400) / var(--heroui-foreground-400-opacity, var(--tw-text-opacity)));
}
.text-foreground-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-500) / var(--heroui-foreground-500-opacity, var(--tw-text-opacity)));
}
.text-foreground-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-600) / var(--heroui-foreground-600-opacity, var(--tw-text-opacity)));
}
.text-foreground\\/50 {
  color: hsl(var(--heroui-foreground) / 0.5);
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-primary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}
.text-primary-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-300) / var(--heroui-primary-300-opacity, var(--tw-text-opacity)));
}
.text-primary-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-400) / var(--heroui-primary-400-opacity, var(--tw-text-opacity)));
}
.text-primary-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-500) / var(--heroui-primary-500-opacity, var(--tw-text-opacity)));
}
.text-primary-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-600) / var(--heroui-primary-600-opacity, var(--tw-text-opacity)));
}
.text-primary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.text-primary\\/20 {
  color: hsl(var(--heroui-primary) / 0.2);
}
.text-primary\\/80 {
  color: hsl(var(--heroui-primary) / 0.8);
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}
.text-secondary-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-300) / var(--heroui-secondary-300-opacity, var(--tw-text-opacity)));
}
.text-secondary-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-400) / var(--heroui-secondary-400-opacity, var(--tw-text-opacity)));
}
.text-secondary-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-500) / var(--heroui-secondary-500-opacity, var(--tw-text-opacity)));
}
.text-secondary-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-600) / var(--heroui-secondary-600-opacity, var(--tw-text-opacity)));
}
.text-secondary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.text-secondary\\/80 {
  color: hsl(var(--heroui-secondary) / 0.8);
}
.text-success {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}
.text-success-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-400) / var(--heroui-success-400-opacity, var(--tw-text-opacity)));
}
.text-success-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-500) / var(--heroui-success-500-opacity, var(--tw-text-opacity)));
}
.text-success-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}
.text-success-700 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-700) / var(--heroui-success-700-opacity, var(--tw-text-opacity)));
}
.text-success-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}
.text-success\\/80 {
  color: hsl(var(--heroui-success) / 0.8);
}
.text-transparent {
  color: transparent;
}
.text-warning {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}
.text-warning-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-400) / var(--heroui-warning-400-opacity, var(--tw-text-opacity)));
}
.text-warning-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-500) / var(--heroui-warning-500-opacity, var(--tw-text-opacity)));
}
.text-warning-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}
.text-warning-700 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-700) / var(--heroui-warning-700-opacity, var(--tw-text-opacity)));
}
.text-warning-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.text-warning\\/80 {
  color: hsl(var(--heroui-warning) / 0.8);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subpixel-antialiased {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-\\[0\\.0001\\] {
  opacity: 0.0001;
}
.opacity-\\[value\\] {
  opacity: value;
}
.opacity-disabled {
  opacity: var(--heroui-disabled-opacity);
}
.mix-blend-luminosity {
  mix-blend-mode: luminosity;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_20px_20px_0px_rgb\\(0_0_0\\/0\\.05\\)\\] {
  --tw-shadow: 0px 20px 20px 0px rgb(0 0 0/0.05);
  --tw-shadow-colored: 0px 20px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-large {
  --tw-shadow: var(--heroui-box-shadow-large);
  --tw-shadow-colored: var(--heroui-box-shadow-large);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-medium {
  --tw-shadow: var(--heroui-box-shadow-medium);
  --tw-shadow-colored: var(--heroui-box-shadow-medium);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-small {
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/5 {
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-danger\\/40 {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-default\\/50 {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-foreground\\/40 {
  --tw-shadow-color: hsl(var(--heroui-foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/40 {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-secondary\\/40 {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-success\\/40 {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-warning\\/40 {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-background {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-ring-opacity)));
}
.ring-danger {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-ring-opacity)));
}
.ring-default {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-ring-opacity)));
}
.ring-focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-focus) / var(--heroui-focus-opacity, var(--tw-ring-opacity)));
}
.ring-primary {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-ring-opacity)));
}
.ring-secondary {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-ring-opacity)));
}
.ring-success {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-ring-opacity)));
}
.ring-transparent {
  --tw-ring-color: transparent;
}
.ring-warning {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-ring-opacity)));
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-lg {
  --tw-blur: blur(16px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-90 {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-150 {
  --tw-saturate: saturate(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-opacity-disabled {
  --tw-backdrop-opacity: opacity(var(--heroui-disabled-opacity));
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-150 {
  --tw-backdrop-saturate: saturate(1.5);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-none {
  transition-property: none !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[color\\2c opacity\\] {
  transition-property: color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[opacity\\2c transform\\] {
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[transform\\2c background-color\\2c color\\] {
  transition-property: transform,background-color,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[transform\\2c color\\2c left\\2c opacity\\] {
  transition-property: transform,color,left,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.\\!duration-100 {
  transition-duration: 100ms !important;
}
.\\!duration-150 {
  transition-duration: 150ms !important;
}
.\\!duration-200 {
  transition-duration: 200ms !important;
}
.\\!duration-250 {
  transition-duration: 250ms !important;
}
.\\!duration-300 {
  transition-duration: 300ms !important;
}
.\\!duration-500 {
  transition-duration: 500ms !important;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.\\!ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.\\!ease-soft-spring {
  transition-timing-function: cubic-bezier(0.155, 1.105, 0.295, 1.12) !important;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-auto {
  will-change: auto;
}
.will-change-transform {
  will-change: transform;
}
:root,.light,[data-theme="light"] {
  color-scheme: light;
  --heroui-background: 0 0% 100%;
  --heroui-foreground-50: 0 0% 98.04%;
  --heroui-foreground-100: 240 4.76% 95.88%;
  --heroui-foreground-200: 240 5.88% 90%;
  --heroui-foreground-300: 240 4.88% 83.92%;
  --heroui-foreground-400: 240 5.03% 64.9%;
  --heroui-foreground-500: 240 3.83% 46.08%;
  --heroui-foreground-600: 240 5.2% 33.92%;
  --heroui-foreground-700: 240 5.26% 26.08%;
  --heroui-foreground-800: 240 3.7% 15.88%;
  --heroui-foreground-900: 240 5.88% 10%;
  --heroui-foreground: 201.81999999999994 24.44% 8.82%;
  --heroui-divider: 0 0% 6.67%;
  --heroui-divider-opacity: 0.15;
  --heroui-focus: 212.01999999999998 100% 46.67%;
  --heroui-overlay: 0 0% 0%;
  --heroui-content1: 0 0% 100%;
  --heroui-content1-foreground: 201.81999999999994 24.44% 8.82%;
  --heroui-content2: 240 4.76% 95.88%;
  --heroui-content2-foreground: 240 3.7% 15.88%;
  --heroui-content3: 240 5.88% 90%;
  --heroui-content3-foreground: 240 5.26% 26.08%;
  --heroui-content4: 240 4.88% 83.92%;
  --heroui-content4-foreground: 240 5.2% 33.92%;
  --heroui-default-50: 0 0% 98.04%;
  --heroui-default-100: 240 4.76% 95.88%;
  --heroui-default-200: 240 5.88% 90%;
  --heroui-default-300: 240 4.88% 83.92%;
  --heroui-default-400: 240 5.03% 64.9%;
  --heroui-default-500: 240 3.83% 46.08%;
  --heroui-default-600: 240 5.2% 33.92%;
  --heroui-default-700: 240 5.26% 26.08%;
  --heroui-default-800: 240 3.7% 15.88%;
  --heroui-default-900: 240 5.88% 10%;
  --heroui-default-foreground: 0 0% 0%;
  --heroui-default: 240 4.88% 83.92%;
  --heroui-primary-50: 212.5 92.31% 94.9%;
  --heroui-primary-100: 211.84000000000003 92.45% 89.61%;
  --heroui-primary-200: 211.84000000000003 92.45% 79.22%;
  --heroui-primary-300: 212.24 92.45% 68.82%;
  --heroui-primary-400: 212.14 92.45% 58.43%;
  --heroui-primary-500: 212.01999999999998 100% 46.67%;
  --heroui-primary-600: 212.14 100% 38.43%;
  --heroui-primary-700: 212.24 100% 28.82%;
  --heroui-primary-800: 211.84000000000003 100% 19.22%;
  --heroui-primary-900: 211.84000000000003 100% 9.61%;
  --heroui-primary-foreground: 0 0% 100%;
  --heroui-primary: 212.01999999999998 100% 46.67%;
  --heroui-secondary-50: 270 61.54% 94.9%;
  --heroui-secondary-100: 270 59.26% 89.41%;
  --heroui-secondary-200: 270 59.26% 78.82%;
  --heroui-secondary-300: 270 59.26% 68.24%;
  --heroui-secondary-400: 270 59.26% 57.65%;
  --heroui-secondary-500: 270 66.67% 47.06%;
  --heroui-secondary-600: 270 66.67% 37.65%;
  --heroui-secondary-700: 270 66.67% 28.24%;
  --heroui-secondary-800: 270 66.67% 18.82%;
  --heroui-secondary-900: 270 66.67% 9.41%;
  --heroui-secondary-foreground: 0 0% 100%;
  --heroui-secondary: 270 66.67% 47.06%;
  --heroui-success-50: 146.66999999999996 64.29% 94.51%;
  --heroui-success-100: 145.71000000000004 61.4% 88.82%;
  --heroui-success-200: 146.2 61.74% 77.45%;
  --heroui-success-300: 145.78999999999996 62.57% 66.47%;
  --heroui-success-400: 146.01 62.45% 55.1%;
  --heroui-success-500: 145.96000000000004 79.46% 43.92%;
  --heroui-success-600: 146.01 79.89% 35.1%;
  --heroui-success-700: 145.78999999999996 79.26% 26.47%;
  --heroui-success-800: 146.2 79.78% 17.45%;
  --heroui-success-900: 145.71000000000004 77.78% 8.82%;
  --heroui-success-foreground: 0 0% 0%;
  --heroui-success: 145.96000000000004 79.46% 43.92%;
  --heroui-warning-50: 54.55000000000001 91.67% 95.29%;
  --heroui-warning-100: 37.139999999999986 91.3% 90.98%;
  --heroui-warning-200: 37.139999999999986 91.3% 81.96%;
  --heroui-warning-300: 36.95999999999998 91.24% 73.14%;
  --heroui-warning-400: 37.00999999999999 91.26% 64.12%;
  --heroui-warning-500: 37.02999999999997 91.27% 55.1%;
  --heroui-warning-600: 37.00999999999999 74.22% 44.12%;
  --heroui-warning-700: 36.95999999999998 73.96% 33.14%;
  --heroui-warning-800: 37.139999999999986 75% 21.96%;
  --heroui-warning-900: 37.139999999999986 75% 10.98%;
  --heroui-warning-foreground: 0 0% 0%;
  --heroui-warning: 37.02999999999997 91.27% 55.1%;
  --heroui-danger-50: 339.13 92% 95.1%;
  --heroui-danger-100: 340 91.84% 90.39%;
  --heroui-danger-200: 339.3299999999999 90% 80.39%;
  --heroui-danger-300: 339.11 90.6% 70.78%;
  --heroui-danger-400: 339 90% 60.78%;
  --heroui-danger-500: 339.20000000000005 90.36% 51.18%;
  --heroui-danger-600: 339 86.54% 40.78%;
  --heroui-danger-700: 339.11 85.99% 30.78%;
  --heroui-danger-800: 339.3299999999999 86.54% 20.39%;
  --heroui-danger-900: 340 84.91% 10.39%;
  --heroui-danger-foreground: 0 0% 100%;
  --heroui-danger: 339.20000000000005 90.36% 51.18%;
  --heroui-divider-weight: 1px;
  --heroui-disabled-opacity: .5;
  --heroui-font-size-tiny: 0.75rem;
  --heroui-font-size-small: 0.875rem;
  --heroui-font-size-medium: 1rem;
  --heroui-font-size-large: 1.125rem;
  --heroui-line-height-tiny: 1rem;
  --heroui-line-height-small: 1.25rem;
  --heroui-line-height-medium: 1.5rem;
  --heroui-line-height-large: 1.75rem;
  --heroui-radius-small: 8px;
  --heroui-radius-medium: 12px;
  --heroui-radius-large: 14px;
  --heroui-border-width-small: 1px;
  --heroui-border-width-medium: 2px;
  --heroui-border-width-large: 3px;
  --heroui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.02), 0px 2px 10px 0px rgb(0 0 0 / 0.06), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.03), 0px 2px 30px 0px rgb(0 0 0 / 0.08), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.04), 0px 30px 60px 0px rgb(0 0 0 / 0.12), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-hover-opacity: .8;
}
.dark,[data-theme="dark"] {
  color-scheme: dark;
  --heroui-background: 0 0% 0%;
  --heroui-foreground-50: 240 5.88% 10%;
  --heroui-foreground-100: 240 3.7% 15.88%;
  --heroui-foreground-200: 240 5.26% 26.08%;
  --heroui-foreground-300: 240 5.2% 33.92%;
  --heroui-foreground-400: 240 3.83% 46.08%;
  --heroui-foreground-500: 240 5.03% 64.9%;
  --heroui-foreground-600: 240 4.88% 83.92%;
  --heroui-foreground-700: 240 5.88% 90%;
  --heroui-foreground-800: 240 4.76% 95.88%;
  --heroui-foreground-900: 0 0% 98.04%;
  --heroui-foreground: 210 5.56% 92.94%;
  --heroui-focus: 212.01999999999998 100% 46.67%;
  --heroui-overlay: 0 0% 0%;
  --heroui-divider: 0 0% 100%;
  --heroui-divider-opacity: 0.15;
  --heroui-content1: 240 5.88% 10%;
  --heroui-content1-foreground: 0 0% 98.04%;
  --heroui-content2: 240 3.7% 15.88%;
  --heroui-content2-foreground: 240 4.76% 95.88%;
  --heroui-content3: 240 5.26% 26.08%;
  --heroui-content3-foreground: 240 5.88% 90%;
  --heroui-content4: 240 5.2% 33.92%;
  --heroui-content4-foreground: 240 4.88% 83.92%;
  --heroui-default-50: 240 5.88% 10%;
  --heroui-default-100: 240 3.7% 15.88%;
  --heroui-default-200: 240 5.26% 26.08%;
  --heroui-default-300: 240 5.2% 33.92%;
  --heroui-default-400: 240 3.83% 46.08%;
  --heroui-default-500: 240 5.03% 64.9%;
  --heroui-default-600: 240 4.88% 83.92%;
  --heroui-default-700: 240 5.88% 90%;
  --heroui-default-800: 240 4.76% 95.88%;
  --heroui-default-900: 0 0% 98.04%;
  --heroui-default-foreground: 0 0% 100%;
  --heroui-default: 240 5.26% 26.08%;
  --heroui-primary-50: 211.84000000000003 100% 9.61%;
  --heroui-primary-100: 211.84000000000003 100% 19.22%;
  --heroui-primary-200: 212.24 100% 28.82%;
  --heroui-primary-300: 212.14 100% 38.43%;
  --heroui-primary-400: 212.01999999999998 100% 46.67%;
  --heroui-primary-500: 212.14 92.45% 58.43%;
  --heroui-primary-600: 212.24 92.45% 68.82%;
  --heroui-primary-700: 211.84000000000003 92.45% 79.22%;
  --heroui-primary-800: 211.84000000000003 92.45% 89.61%;
  --heroui-primary-900: 212.5 92.31% 94.9%;
  --heroui-primary-foreground: 0 0% 100%;
  --heroui-primary: 212.01999999999998 100% 46.67%;
  --heroui-secondary-50: 270 66.67% 9.41%;
  --heroui-secondary-100: 270 66.67% 18.82%;
  --heroui-secondary-200: 270 66.67% 28.24%;
  --heroui-secondary-300: 270 66.67% 37.65%;
  --heroui-secondary-400: 270 66.67% 47.06%;
  --heroui-secondary-500: 270 59.26% 57.65%;
  --heroui-secondary-600: 270 59.26% 68.24%;
  --heroui-secondary-700: 270 59.26% 78.82%;
  --heroui-secondary-800: 270 59.26% 89.41%;
  --heroui-secondary-900: 270 61.54% 94.9%;
  --heroui-secondary-foreground: 0 0% 100%;
  --heroui-secondary: 270 59.26% 57.65%;
  --heroui-success-50: 145.71000000000004 77.78% 8.82%;
  --heroui-success-100: 146.2 79.78% 17.45%;
  --heroui-success-200: 145.78999999999996 79.26% 26.47%;
  --heroui-success-300: 146.01 79.89% 35.1%;
  --heroui-success-400: 145.96000000000004 79.46% 43.92%;
  --heroui-success-500: 146.01 62.45% 55.1%;
  --heroui-success-600: 145.78999999999996 62.57% 66.47%;
  --heroui-success-700: 146.2 61.74% 77.45%;
  --heroui-success-800: 145.71000000000004 61.4% 88.82%;
  --heroui-success-900: 146.66999999999996 64.29% 94.51%;
  --heroui-success-foreground: 0 0% 0%;
  --heroui-success: 145.96000000000004 79.46% 43.92%;
  --heroui-warning-50: 37.139999999999986 75% 10.98%;
  --heroui-warning-100: 37.139999999999986 75% 21.96%;
  --heroui-warning-200: 36.95999999999998 73.96% 33.14%;
  --heroui-warning-300: 37.00999999999999 74.22% 44.12%;
  --heroui-warning-400: 37.02999999999997 91.27% 55.1%;
  --heroui-warning-500: 37.00999999999999 91.26% 64.12%;
  --heroui-warning-600: 36.95999999999998 91.24% 73.14%;
  --heroui-warning-700: 37.139999999999986 91.3% 81.96%;
  --heroui-warning-800: 37.139999999999986 91.3% 90.98%;
  --heroui-warning-900: 54.55000000000001 91.67% 95.29%;
  --heroui-warning-foreground: 0 0% 0%;
  --heroui-warning: 37.02999999999997 91.27% 55.1%;
  --heroui-danger-50: 340 84.91% 10.39%;
  --heroui-danger-100: 339.3299999999999 86.54% 20.39%;
  --heroui-danger-200: 339.11 85.99% 30.78%;
  --heroui-danger-300: 339 86.54% 40.78%;
  --heroui-danger-400: 339.20000000000005 90.36% 51.18%;
  --heroui-danger-500: 339 90% 60.78%;
  --heroui-danger-600: 339.11 90.6% 70.78%;
  --heroui-danger-700: 339.3299999999999 90% 80.39%;
  --heroui-danger-800: 340 91.84% 90.39%;
  --heroui-danger-900: 339.13 92% 95.1%;
  --heroui-danger-foreground: 0 0% 100%;
  --heroui-danger: 339.20000000000005 90.36% 51.18%;
  --heroui-divider-weight: 1px;
  --heroui-disabled-opacity: .5;
  --heroui-font-size-tiny: 0.75rem;
  --heroui-font-size-small: 0.875rem;
  --heroui-font-size-medium: 1rem;
  --heroui-font-size-large: 1.125rem;
  --heroui-line-height-tiny: 1rem;
  --heroui-line-height-small: 1.25rem;
  --heroui-line-height-medium: 1.5rem;
  --heroui-line-height-large: 1.75rem;
  --heroui-radius-small: 8px;
  --heroui-radius-medium: 12px;
  --heroui-radius-large: 14px;
  --heroui-border-width-small: 1px;
  --heroui-border-width-medium: 2px;
  --heroui-border-width-large: 3px;
  --heroui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.05), 0px 2px 10px 0px rgb(0 0 0 / 0.2), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --heroui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.06), 0px 2px 30px 0px rgb(0 0 0 / 0.22), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --heroui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.07), 0px 30px 60px 0px rgb(0 0 0 / 0.26), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --heroui-hover-opacity: .9;
}
.leading-inherit {
  line-height: inherit;
}
.bg-img-inherit {
  background-image: inherit;
}
.bg-clip-inherit {
  background-clip: inherit;
}
.text-fill-inherit {
  -webkit-text-fill-color: inherit;
}
.tap-highlight-transparent {
  -webkit-tap-highlight-color: transparent;
}
.input-search-cancel-button-none::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.transition-background {
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-colors-opacity {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-width {
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-height {
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-size {
  transition-property: width, height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-left {
  transition-property: left;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-opacity {
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-background {
  transition-property: transform, background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-colors {
  transition-property: transform, color, background, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-colors-opacity {
  transition-property: transform, color, background, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-default {
  -ms-overflow-style: auto;
  scrollbar-width: auto;
}
.scrollbar-default::-webkit-scrollbar {
  display: block;
}
.spinner-bar-animation {
  animation-delay: calc(-1.2s + (0.1s * var(--bar-index)));
  transform: rotate(calc(30deg * var(--bar-index)))translate(140%);
}
.spinner-dot-animation {
  animation-delay: calc(250ms * var(--dot-index));
}
.spinner-dot-blink-animation {
  animation-delay: calc(200ms * var(--dot-index));
}
.\\[--picker-height\\:224px\\] {
  --picker-height: 224px;
}
.\\[--scale-enter\\:100\\%\\] {
  --scale-enter: 100%;
}
.\\[--scale-exit\\:100\\%\\] {
  --scale-exit: 100%;
}
.\\[--scroll-shadow-size\\:100px\\] {
  --scroll-shadow-size: 100px;
}
.\\[--slide-enter\\:0px\\] {
  --slide-enter: 0px;
}
.\\[--slide-exit\\:80px\\] {
  --slide-exit: 80px;
}
.\\[-webkit-mask\\:radial-gradient\\(closest-side\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.0\\)calc\\(100\\%-3px\\)\\2c rgba\\(0\\2c 0\\2c 0\\2c 1\\)calc\\(100\\%-3px\\)\\)\\] {
  -webkit-mask: radial-gradient(closest-side,rgba(0,0,0,0.0)calc(100% - 3px),rgba(0,0,0,1)calc(100% - 3px));
}
.\\[animation-duration\\:1s\\] {
  animation-duration: 1s;
}
.\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\] {
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

/* Globalne style */

/* Theme transitions for smooth theme switching */
:root {
  --transition-duration: 0.5s;
}

html {
  transition: color var(--transition-duration), background-color var(--transition-duration);
}

html.dark {
  color-scheme: dark;
}

body {
  font-family: 'Inter', sans-serif;
  scroll-behavior: smooth;
}

/* Animacje */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Klasy pomocnicze do animacji */
.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-pulse-slow {
  animation: pulse 4s ease-in-out infinite;
}

.animate-gradient {
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}

/* Dodatkowe style dla przycisków animowanych */
.btn-animated:hover {
  transform: translateY(-3px);
  transition: transform 0.3s ease;
}

/* Klasa dla efektu szkła */
.glass-effect {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-border-opacity)));
  background-color: hsl(var(--heroui-background) / 0.6);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

/* Efekty hover dla kart */
.card-hover-effect {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-hover-effect:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 30px -10px rgba(var(--color-primary-500), 0.3);
}

.badge-logo {
  margin-top: 12px;
  margin-right: -10px;
}

.file\\:cursor-pointer::file-selector-button {
  cursor: pointer;
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.placeholder\\:text-danger::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.placeholder\\:text-foreground-500::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-500) / var(--heroui-foreground-500-opacity, var(--tw-text-opacity)));
}

.placeholder\\:text-primary::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.placeholder\\:text-secondary::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.placeholder\\:text-success-600::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.placeholder\\:text-warning-600::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}

.before\\:z-0::before {
  content: var(--tw-content);
  z-index: 0;
}

.before\\:z-\\[-1\\]::before {
  content: var(--tw-content);
  z-index: -1;
}

.before\\:box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:hidden::before {
  content: var(--tw-content);
  display: none;
}

.before\\:h-0\\.5::before {
  content: var(--tw-content);
  height: 0.125rem;
}

.before\\:h-11::before {
  content: var(--tw-content);
  height: 2.75rem;
}

.before\\:h-2\\.5::before {
  content: var(--tw-content);
  height: 0.625rem;
}

.before\\:h-4::before {
  content: var(--tw-content);
  height: 1rem;
}

.before\\:h-6::before {
  content: var(--tw-content);
  height: 1.5rem;
}

.before\\:h-8::before {
  content: var(--tw-content);
  height: 2rem;
}

.before\\:h-px::before {
  content: var(--tw-content);
  height: 1px;
}

.before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}

.before\\:w-11::before {
  content: var(--tw-content);
  width: 2.75rem;
}

.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:w-6::before {
  content: var(--tw-content);
  width: 1.5rem;
}

.before\\:w-8::before {
  content: var(--tw-content);
  width: 2rem;
}

.before\\:-translate-x-full::before {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-1::before {
  content: var(--tw-content);
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rotate-0::before {
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes shimmer {

  100% {
    content: var(--tw-content);
    transform: translateX(100%);
  }
}

.before\\:animate-\\[shimmer_2s_infinite\\]::before {
  content: var(--tw-content);
  animation: shimmer 2s infinite;
}

.before\\:animate-none::before {
  content: var(--tw-content);
  animation: none;
}

.before\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.5);
}

.before\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.6);
}

.before\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.7);
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:rounded-none::before {
  content: var(--tw-content);
  border-radius: 0px;
}

.before\\:rounded-sm::before {
  content: var(--tw-content);
  border-radius: 0.125rem;
}

.before\\:border-2::before {
  content: var(--tw-content);
  border-width: 2px;
}

.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}

.before\\:border-solid::before {
  content: var(--tw-content);
  border-style: solid;
}

.before\\:border-content4\\/30::before {
  content: var(--tw-content);
  border-color: hsl(var(--heroui-content4) / 0.3);
}

.before\\:border-danger::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.before\\:border-default::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-border-opacity)));
}

.before\\:bg-content1::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content1) / var(--heroui-content1-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-current::before {
  content: var(--tw-content);
  background-color: currentColor;
}

.before\\:bg-danger::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-danger\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-danger) / 0.2);
}

.before\\:bg-default\\/60::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-default) / 0.6);
}

.before\\:bg-foreground::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-primary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-primary\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-primary) / 0.2);
}

.before\\:bg-secondary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-secondary\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-secondary) / 0.2);
}

.before\\:bg-success::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-success\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-success) / 0.2);
}

.before\\:bg-warning::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.before\\:bg-warning\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-warning) / 0.2);
}

.before\\:bg-gradient-to-r::before {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.before\\:from-transparent::before {
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.before\\:via-content4::before {
  content: var(--tw-content);
  --tw-gradient-to: hsl(var(--heroui-content4) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-content4) / var(--heroui-content4-opacity, 1)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.before\\:to-transparent::before {
  content: var(--tw-content);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}

.before\\:opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}

.before\\:shadow-small::before {
  content: var(--tw-content);
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.before\\:transition-colors::before {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}

.before\\:transition-none::before {
  content: var(--tw-content);
  transition-property: none;
}

.before\\:transition-transform::before {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}

.before\\:duration-150::before {
  content: var(--tw-content);
  transition-duration: 150ms;
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.before\\:transition-width::before {
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}

.after\\:-bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}

.after\\:-bottom-\\[2px\\]::after {
  content: var(--tw-content);
  bottom: -2px;
}

.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}

.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}

.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}

.after\\:right-0::after {
  content: var(--tw-content);
  right: 0px;
}

.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}

.after\\:-z-10::after {
  content: var(--tw-content);
  z-index: -10;
}

.after\\:z-0::after {
  content: var(--tw-content);
  z-index: 0;
}

.after\\:ml-0\\.5::after {
  content: var(--tw-content);
  margin-left: 0.125rem;
}

.after\\:ms-0\\.5::after {
  content: var(--tw-content);
  margin-inline-start: 0.125rem;
}

.after\\:block::after {
  content: var(--tw-content);
  display: block;
}

.after\\:h-0::after {
  content: var(--tw-content);
  height: 0px;
}

.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:h-\\[2px\\]::after {
  content: var(--tw-content);
  height: 2px;
}

.after\\:h-divider::after {
  content: var(--tw-content);
  height: var(--heroui-divider-weight);
}

.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}

.after\\:h-px::after {
  content: var(--tw-content);
  height: 1px;
}

.after\\:w-0::after {
  content: var(--tw-content);
  width: 0px;
}

.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}

.after\\:w-\\[80\\%\\]::after {
  content: var(--tw-content);
  width: 80%;
}

.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}

.after\\:origin-center::after {
  content: var(--tw-content);
  transform-origin: center;
}

.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:translate-y-1::after {
  content: var(--tw-content);
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rotate-0::after {
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:scale-50::after {
  content: var(--tw-content);
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.large\\)\\/2\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-large) / 2);
}

.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.5);
}

.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.6);
}

.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.7);
}

.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\/3\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) / 3);
}

.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.small\\)\\/3\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-small) / 3);
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:rounded-none::after {
  content: var(--tw-content);
  border-radius: 0px;
}

.after\\:rounded-xl::after {
  content: var(--tw-content);
  border-radius: 0.75rem;
}

.after\\:\\!bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity))) !important;
}

.after\\:bg-background::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-content1::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content1) / var(--heroui-content1-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-content3::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content3) / var(--heroui-content3-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-current::after {
  content: var(--tw-content);
  background-color: currentColor;
}

.after\\:bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-default::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-default-foreground::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-divider::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-divider) / var(--heroui-divider-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-foreground::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-primary::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-secondary::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-success::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.after\\:bg-warning::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.after\\:text-danger::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.after\\:text-danger-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.after\\:text-default-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.after\\:text-primary-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.after\\:text-secondary-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.after\\:text-success-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.after\\:text-warning-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.after\\:opacity-0::after {
  content: var(--tw-content);
  opacity: 0;
}

.after\\:opacity-100::after {
  content: var(--tw-content);
  opacity: 1;
}

.after\\:shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]::after {
  content: var(--tw-content);
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.after\\:shadow-small::after {
  content: var(--tw-content);
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}

.after\\:transition-none::after {
  content: var(--tw-content);
  transition-property: none;
}

.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}

.after\\:\\!duration-200::after {
  content: var(--tw-content);
  transition-duration: 200ms !important;
}

.after\\:duration-150::after {
  content: var(--tw-content);
  transition-duration: 150ms;
}

.after\\:\\!ease-linear::after {
  content: var(--tw-content);
  transition-timing-function: linear !important;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:content-\\[\\'\\*\\'\\]::after {
  --tw-content: '*';
  content: var(--tw-content);
}

.after\\:transition-background::after {
  content: var(--tw-content);
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}

.after\\:transition-width::after {
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}

.after\\:transition-height::after {
  content: var(--tw-content);
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}

.after\\:transition-transform-opacity::after {
  content: var(--tw-content);
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}

.first\\:-ml-0\\.5:first-child {
  margin-left: -0.125rem;
}

.first\\:mt-2:first-child {
  margin-top: 0.5rem;
}

.first\\:rounded-s-full:first-child {
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}

.first\\:rounded-s-large:first-child {
  border-start-start-radius: var(--heroui-radius-large);
  border-end-start-radius: var(--heroui-radius-large);
}

.first\\:rounded-s-lg:first-child {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}

.first\\:rounded-s-medium:first-child {
  border-start-start-radius: var(--heroui-radius-medium);
  border-end-start-radius: var(--heroui-radius-medium);
}

.first\\:rounded-s-none:first-child {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}

.first\\:rounded-s-small:first-child {
  border-start-start-radius: var(--heroui-radius-small);
  border-end-start-radius: var(--heroui-radius-small);
}

.first\\:before\\:rounded-s-lg:first-child::before {
  content: var(--tw-content);
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}

.last\\:rounded-e-full:last-child {
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}

.last\\:rounded-e-large:last-child {
  border-start-end-radius: var(--heroui-radius-large);
  border-end-end-radius: var(--heroui-radius-large);
}

.last\\:rounded-e-lg:last-child {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}

.last\\:rounded-e-medium:last-child {
  border-start-end-radius: var(--heroui-radius-medium);
  border-end-end-radius: var(--heroui-radius-medium);
}

.last\\:rounded-e-none:last-child {
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}

.last\\:rounded-e-small:last-child {
  border-start-end-radius: var(--heroui-radius-small);
  border-end-end-radius: var(--heroui-radius-small);
}

.last\\:before\\:rounded-e-lg:last-child::before {
  content: var(--tw-content);
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}

.first-of-type\\:rounded-e-none:first-of-type {
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}

.last-of-type\\:rounded-s-none:last-of-type {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}

.autofill\\:bg-transparent:autofill {
  background-color: transparent;
}

.focus-within\\:border-danger:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.focus-within\\:border-default-400:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}

.focus-within\\:border-default-foreground:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-border-opacity)));
}

.focus-within\\:border-primary:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.focus-within\\:border-secondary:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.focus-within\\:border-success:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.focus-within\\:border-warning:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.focus-within\\:bg-danger-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.focus-within\\:bg-primary-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.focus-within\\:bg-secondary-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.focus-within\\:bg-success-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.focus-within\\:bg-warning-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.focus-within\\:after\\:w-full:focus-within::after {
  content: var(--tw-content);
  width: 100%;
}

.hover\\:-translate-x-0:hover {
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-danger:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.hover\\:border-default:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-border-opacity)));
}

.hover\\:border-default-300:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-border-opacity)));
}

.hover\\:border-default-400:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}

.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.hover\\:border-secondary:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.hover\\:border-success:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.hover\\:border-warning:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.hover\\:\\!bg-foreground:hover {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity))) !important;
}

.hover\\:bg-black\\/50:hover {
  background-color: rgb(0 0 0 / 0.5);
}

.hover\\:bg-danger:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-danger-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-default-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-default-200:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-primary-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-secondary-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-success-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.hover\\:bg-warning-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.hover\\:text-danger-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-600) / var(--heroui-danger-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-default-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--heroui-default-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-foreground-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-600) / var(--heroui-foreground-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-600) / var(--heroui-primary-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-secondary-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-600) / var(--heroui-secondary-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-success-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-warning-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:\\!opacity-100:hover {
  opacity: 1 !important;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:filter-none:hover {
  filter: none;
}

.hover\\:after\\:bg-danger\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-danger) / 0.2);
}

.hover\\:after\\:bg-foreground\\/10:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-foreground) / 0.1);
}

.hover\\:after\\:bg-primary\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-primary) / 0.2);
}

.hover\\:after\\:bg-secondary\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-secondary) / 0.2);
}

.hover\\:after\\:bg-success\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-success) / 0.2);
}

.hover\\:after\\:bg-warning\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-warning) / 0.2);
}

.hover\\:after\\:opacity-100:hover::after {
  content: var(--tw-content);
  opacity: 1;
}

.focus-within\\:hover\\:border-danger:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.focus-within\\:hover\\:border-default-foreground:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-border-opacity)));
}

.focus-within\\:hover\\:border-primary:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.focus-within\\:hover\\:border-secondary:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.focus-within\\:hover\\:border-success:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.focus-within\\:hover\\:border-warning:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.focus-within\\:hover\\:bg-default-100:hover:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.focus\\:bg-danger-400\\/50:focus {
  background-color: hsl(var(--heroui-danger-400) / 0.5);
}

.focus\\:bg-default-400\\/50:focus {
  background-color: hsl(var(--heroui-default-400) / 0.5);
}

.focus\\:bg-primary-400\\/50:focus {
  background-color: hsl(var(--heroui-primary-400) / 0.5);
}

.focus\\:bg-secondary-400\\/50:focus {
  background-color: hsl(var(--heroui-secondary-400) / 0.5);
}

.focus\\:bg-success-400\\/50:focus {
  background-color: hsl(var(--heroui-success-400) / 0.5);
}

.focus\\:bg-warning-400\\/50:focus {
  background-color: hsl(var(--heroui-warning-400) / 0.5);
}

.focus\\:underline:focus {
  text-decoration-line: underline;
}

.focus\\:shadow-sm:focus {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus-visible\\:z-10:focus-visible {
  z-index: 10;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}

.focus-visible\\:outline-focus:focus-visible {
  outline-color: hsl(var(--heroui-focus) / var(--heroui-focus-opacity, 1));
}

.active\\:bg-default-200:active {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.active\\:bg-default-300:active {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-bg-opacity)));
}

.active\\:underline:active {
  text-decoration-line: underline;
}

.active\\:\\!opacity-70:active {
  opacity: 0.7 !important;
}

.active\\:opacity-disabled:active {
  opacity: var(--heroui-disabled-opacity);
}

.disabled\\:cursor-default:disabled {
  cursor: default;
}

.group:hover .group-hover\\:pointer-events-none {
  pointer-events: none;
}

.group:hover .group-hover\\:pointer-events-auto {
  pointer-events: auto;
}

.group:hover .group-hover\\:block {
  display: block;
}

.group:hover .group-hover\\:hidden {
  display: none;
}

.group:hover .group-hover\\:w-full {
  width: 100%;
}

.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-current {
  border-color: currentColor;
}

.group:hover .group-hover\\:text-current {
  color: currentColor;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.has-\\[\\:disabled\\]\\:opacity-60:has(:disabled) {
  opacity: 0.6;
}

.aria-expanded\\:scale-\\[0\\.97\\][aria-expanded="true"] {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.aria-expanded\\:opacity-70[aria-expanded="true"] {
  opacity: 0.7;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}

.data-\\[loaded\\=true\\]\\:pointer-events-auto[data-loaded="true"] {
  pointer-events: auto;
}

.data-\\[visible\\=true\\]\\:pointer-events-auto[data-visible="true"] {
  pointer-events: auto;
}

.data-\\[placement\\=bottom-center\\]\\:fixed[data-placement="bottom-center"] {
  position: fixed;
}

.data-\\[placement\\=bottom-left\\]\\:fixed[data-placement="bottom-left"] {
  position: fixed;
}

.data-\\[placement\\=bottom-right\\]\\:fixed[data-placement="bottom-right"] {
  position: fixed;
}

.data-\\[placement\\=top-center\\]\\:fixed[data-placement="top-center"] {
  position: fixed;
}

.data-\\[placement\\=top-left\\]\\:fixed[data-placement="top-left"] {
  position: fixed;
}

.data-\\[placement\\=top-right\\]\\:fixed[data-placement="top-right"] {
  position: fixed;
}

.data-\\[placement\\=bottom-center\\]\\:bottom-0[data-placement="bottom-center"] {
  bottom: 0px;
}

.data-\\[placement\\=bottom-center\\]\\:left-0[data-placement="bottom-center"] {
  left: 0px;
}

.data-\\[placement\\=bottom-center\\]\\:left-1\\/2[data-placement="bottom-center"] {
  left: 50%;
}

.data-\\[placement\\=bottom-center\\]\\:right-0[data-placement="bottom-center"] {
  right: 0px;
}

.data-\\[placement\\=bottom-left\\]\\:bottom-0[data-placement="bottom-left"] {
  bottom: 0px;
}

.data-\\[placement\\=bottom-left\\]\\:left-0[data-placement="bottom-left"] {
  left: 0px;
}

.data-\\[placement\\=bottom-right\\]\\:bottom-0[data-placement="bottom-right"] {
  bottom: 0px;
}

.data-\\[placement\\=bottom-right\\]\\:right-0[data-placement="bottom-right"] {
  right: 0px;
}

.data-\\[placement\\=top-center\\]\\:left-0[data-placement="top-center"] {
  left: 0px;
}

.data-\\[placement\\=top-center\\]\\:left-1\\/2[data-placement="top-center"] {
  left: 50%;
}

.data-\\[placement\\=top-center\\]\\:right-0[data-placement="top-center"] {
  right: 0px;
}

.data-\\[placement\\=top-center\\]\\:top-0[data-placement="top-center"] {
  top: 0px;
}

.data-\\[placement\\=top-left\\]\\:left-0[data-placement="top-left"] {
  left: 0px;
}

.data-\\[placement\\=top-left\\]\\:top-0[data-placement="top-left"] {
  top: 0px;
}

.data-\\[placement\\=top-right\\]\\:right-0[data-placement="top-right"] {
  right: 0px;
}

.data-\\[placement\\=top-right\\]\\:top-0[data-placement="top-right"] {
  top: 0px;
}

.data-\\[focus-visible\\=true\\]\\:z-10[data-focus-visible="true"] {
  z-index: 10;
}

.data-\\[focused\\=true\\]\\:z-10[data-focused="true"] {
  z-index: 10;
}

.data-\\[placement\\=bottom-left\\]\\:mx-auto[data-placement="bottom-left"] {
  margin-left: auto;
  margin-right: auto;
}

.data-\\[placement\\=bottom-right\\]\\:mx-auto[data-placement="bottom-right"] {
  margin-left: auto;
  margin-right: auto;
}

.data-\\[placement\\=top-left\\]\\:mx-auto[data-placement="top-left"] {
  margin-left: auto;
  margin-right: auto;
}

.data-\\[placement\\=top-right\\]\\:mx-auto[data-placement="top-right"] {
  margin-left: auto;
  margin-right: auto;
}

.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_10px\\)\\][data-has-label="true"] {
  margin-top: calc(var(--heroui-font-size-small) + 10px);
}

.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_12px\\)\\][data-has-label="true"] {
  margin-top: calc(var(--heroui-font-size-small) + 12px);
}

.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_8px\\)\\][data-has-label="true"] {
  margin-top: calc(var(--heroui-font-size-small) + 8px);
}

.data-\\[open\\=true\\]\\:block[data-open="true"] {
  display: block;
}

.data-\\[open\\=true\\]\\:flex[data-open="true"] {
  display: flex;
}

.data-\\[placement\\=bottom-center\\]\\:flex[data-placement="bottom-center"] {
  display: flex;
}

.data-\\[placement\\=bottom-left\\]\\:flex[data-placement="bottom-left"] {
  display: flex;
}

.data-\\[placement\\=bottom-right\\]\\:flex[data-placement="bottom-right"] {
  display: flex;
}

.data-\\[placement\\=top-center\\]\\:flex[data-placement="top-center"] {
  display: flex;
}

.data-\\[placement\\=top-left\\]\\:flex[data-placement="top-left"] {
  display: flex;
}

.data-\\[placement\\=top-right\\]\\:flex[data-placement="top-right"] {
  display: flex;
}

.data-\\[hidden\\=true\\]\\:hidden[data-hidden="true"] {
  display: none;
}

.data-\\[inert\\=true\\]\\:hidden[data-inert="true"] {
  display: none;
}

.data-\\[justify\\=end\\]\\:flex-grow[data-justify="end"] {
  flex-grow: 1;
}

.data-\\[justify\\=start\\]\\:flex-grow[data-justify="start"] {
  flex-grow: 1;
}

.data-\\[justify\\=end\\]\\:basis-0[data-justify="end"] {
  flex-basis: 0px;
}

.data-\\[justify\\=start\\]\\:basis-0[data-justify="start"] {
  flex-basis: 0px;
}

.data-\\[animation\\=exiting\\]\\:data-\\[placement\\=bottom-center\\]\\:translate-y-28[data-placement="bottom-center"][data-animation="exiting"] {
  --tw-translate-y: 7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[animation\\=exiting\\]\\:data-\\[placement\\=bottom-left\\]\\:-translate-x-28[data-placement="bottom-left"][data-animation="exiting"] {
  --tw-translate-x: -7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[animation\\=exiting\\]\\:data-\\[placement\\=bottom-right\\]\\:translate-x-28[data-placement="bottom-right"][data-animation="exiting"] {
  --tw-translate-x: 7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[animation\\=exiting\\]\\:data-\\[placement\\=top-center\\]\\:-translate-y-28[data-placement="top-center"][data-animation="exiting"] {
  --tw-translate-y: -7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[animation\\=exiting\\]\\:data-\\[placement\\=top-left\\]\\:-translate-x-28[data-placement="top-left"][data-animation="exiting"] {
  --tw-translate-x: -7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[animation\\=exiting\\]\\:data-\\[placement\\=top-right\\]\\:translate-x-28[data-placement="top-right"][data-animation="exiting"] {
  --tw-translate-x: 7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[focus-visible\\=true\\]\\:-translate-x-3[data-focus-visible="true"] {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[hover\\=true\\]\\:-translate-x-3[data-hover="true"] {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[hover\\=true\\]\\:translate-x-0[data-hover="true"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=bottom-center\\]\\:-translate-x-1\\/2[data-placement="bottom-center"] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=top-center\\]\\:-translate-x-1\\/2[data-placement="top-center"] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[before\\=true\\]\\:rotate-180[data-before="true"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[direction\\=ascending\\]\\:rotate-180[data-direction="ascending"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[open\\=true\\]\\:-rotate-90[data-open="true"] {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[open\\=true\\]\\:rotate-180[data-open="true"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[active\\=true\\]\\:scale-100[data-active="true"] {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[active\\=true\\]\\:scale-110[data-active="true"] {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[invisible\\=true\\]\\:scale-0[data-invisible="true"] {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[pressed\\=true\\]\\:scale-100[data-pressed="true"] {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[pressed\\=true\\]\\:scale-\\[0\\.97\\][data-pressed="true"] {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[animation\\=exiting\\]\\:transform[data-animation="exiting"] {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[disabled\\=true\\]\\:cursor-default[data-disabled="true"] {
  cursor: default;
}

.data-\\[disabled\\=true\\]\\:cursor-not-allowed[data-disabled="true"] {
  cursor: not-allowed;
}

.data-\\[dragging\\=true\\]\\:cursor-grabbing[data-dragging="true"] {
  cursor: grabbing;
}

.data-\\[readonly\\=true\\]\\:cursor-default[data-readonly="true"] {
  cursor: default;
}

.data-\\[sortable\\=true\\]\\:cursor-pointer[data-sortable="true"] {
  cursor: pointer;
}

.data-\\[unavailable\\=true\\]\\:cursor-default[data-unavailable="true"] {
  cursor: default;
}

.data-\\[visible\\=true\\]\\:cursor-pointer[data-visible="true"] {
  cursor: pointer;
}

.data-\\[orientation\\=horizontal\\]\\:flex-row[data-orientation="horizontal"] {
  flex-direction: row;
}

.data-\\[placement\\=bottom-center\\]\\:flex-col[data-placement="bottom-center"] {
  flex-direction: column;
}

.data-\\[placement\\=bottom-left\\]\\:flex-col[data-placement="bottom-left"] {
  flex-direction: column;
}

.data-\\[placement\\=bottom-right\\]\\:flex-col[data-placement="bottom-right"] {
  flex-direction: column;
}

.data-\\[placement\\=top-center\\]\\:flex-col[data-placement="top-center"] {
  flex-direction: column;
}

.data-\\[placement\\=top-left\\]\\:flex-col[data-placement="top-left"] {
  flex-direction: column;
}

.data-\\[placement\\=top-right\\]\\:flex-col[data-placement="top-right"] {
  flex-direction: column;
}

.data-\\[has-helper\\=true\\]\\:items-start[data-has-helper="true"] {
  align-items: flex-start;
}

.data-\\[justify\\=start\\]\\:justify-start[data-justify="start"] {
  justify-content: flex-start;
}

.data-\\[justify\\=end\\]\\:justify-end[data-justify="end"] {
  justify-content: flex-end;
}

.data-\\[justify\\=center\\]\\:justify-center[data-justify="center"] {
  justify-content: center;
}

.data-\\[loaded\\=true\\]\\:overflow-visible[data-loaded="true"] {
  overflow: visible;
}

.data-\\[has-multiple-rows\\=true\\]\\:rounded-large[data-has-multiple-rows="true"] {
  border-radius: var(--heroui-radius-large);
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:rounded-full[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  border-radius: 9999px;
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:rounded-full[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  border-radius: 9999px;
}

.data-\\[menu-open\\=true\\]\\:border-none[data-menu-open="true"] {
  border-style: none;
}

.data-\\[active\\=true\\]\\:border-danger[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-danger-400[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-400) / var(--heroui-danger-400-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-default-300[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-default-400[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-foreground[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-primary[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-secondary[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-success[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:border-warning[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-danger[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-default-400[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-default-foreground[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-primary[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-secondary[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-success[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.data-\\[focus\\=true\\]\\:border-warning[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-danger[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-default[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-default-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-primary[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-secondary[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-success[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.data-\\[hover\\=true\\]\\:border-warning[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-danger[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-default-400[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-default-foreground[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-primary[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-secondary[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-success[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.data-\\[open\\=true\\]\\:border-warning[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.data-\\[active\\=true\\]\\:bg-danger[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-danger-100[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-danger-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-200) / var(--heroui-danger-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-default-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-default-400[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-primary[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-primary-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-200) / var(--heroui-primary-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-secondary[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-secondary-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-200) / var(--heroui-secondary-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-success[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-success-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-200) / var(--heroui-success-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-warning[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[active\\=true\\]\\:bg-warning-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-200) / var(--heroui-warning-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:\\!bg-danger[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!bg-danger-100[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!bg-default[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!bg-primary[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!bg-secondary[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!bg-success[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!bg-warning[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:bg-content2[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content2) / var(--heroui-content2-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-danger-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-danger-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-danger\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-danger) / 0.2);
}

.data-\\[hover\\=true\\]\\:bg-default[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-default-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-default-200[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-default\\/40[data-hover="true"] {
  background-color: hsl(var(--heroui-default) / 0.4);
}

.data-\\[hover\\=true\\]\\:bg-foreground-200[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground-200) / var(--heroui-foreground-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-primary[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-primary-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-primary\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-primary) / 0.2);
}

.data-\\[hover\\=true\\]\\:bg-secondary[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-secondary-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-secondary\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-secondary) / 0.2);
}

.data-\\[hover\\=true\\]\\:bg-success[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-success-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--heroui-success-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-success-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-success\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-success) / 0.2);
}

.data-\\[hover\\=true\\]\\:bg-transparent[data-hover="true"] {
  background-color: transparent;
}

.data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-warning-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-warning-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\=true\\]\\:bg-warning\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-warning) / 0.2);
}

.data-\\[hover\\]\\:bg-danger-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-200) / var(--heroui-danger-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-danger-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-default-100[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-primary-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-200) / var(--heroui-primary-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-primary-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-secondary-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-200) / var(--heroui-secondary-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-secondary-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-success-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-200) / var(--heroui-success-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-success-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-warning-100[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[hover\\]\\:bg-warning-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-200) / var(--heroui-warning-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=false\\]\\:bg-default-200[data-in-range="false"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=true\\]\\:bg-background\\/50[data-in-range="true"] {
  background-color: hsl(var(--heroui-background) / 0.5);
}

.data-\\[in-range\\=true\\]\\:bg-danger[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=true\\]\\:bg-foreground[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=true\\]\\:bg-primary[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=true\\]\\:bg-secondary[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=true\\]\\:bg-success[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[in-range\\=true\\]\\:bg-warning[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[loaded\\=true\\]\\:\\!bg-transparent[data-loaded="true"] {
  background-color: transparent !important;
}

.data-\\[selected\\=true\\]\\:bg-danger[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:bg-default[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:bg-foreground[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:bg-primary[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:bg-secondary[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:bg-success[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:bg-warning[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-foreground[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-primary[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-secondary[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-success[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-transparent[data-range-selection="true"][data-selected="true"] {
  background-color: transparent;
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:bg-transparent[data-outside-month="true"][data-range-selection="true"][data-selected="true"] {
  background-color: transparent;
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-danger[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-primary[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-secondary[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-success[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-warning[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-danger[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-primary[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-secondary[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-success[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-warning[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[has-end-content\\=true\\]\\:pe-1\\.5[data-has-end-content="true"] {
  padding-inline-end: 0.375rem;
}

.data-\\[has-helper\\=true\\]\\:pb-\\[calc\\(theme\\(fontSize\\.tiny\\)_\\+8px\\)\\][data-has-helper="true"] {
  padding-bottom: calc(var(--heroui-font-size-tiny) + 8px);
}

.data-\\[has-helper\\=true\\]\\:pb-\\[calc\\(theme\\(fontSize\\.tiny\\)_\\+_8px\\)\\][data-has-helper="true"] {
  padding-bottom: calc(var(--heroui-font-size-tiny) + 8px);
}

.data-\\[has-start-content\\=true\\]\\:ps-1\\.5[data-has-start-content="true"] {
  padding-inline-start: 0.375rem;
}

.data-\\[has-title\\=true\\]\\:pt-1[data-has-title="true"] {
  padding-top: 0.25rem;
}

.data-\\[active\\=true\\]\\:font-semibold[data-active="true"] {
  font-weight: 600;
}

.data-\\[selected\\=true\\]\\:font-semibold[data-selected="true"] {
  font-weight: 600;
}

.data-\\[active\\=true\\]\\:text-danger-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[active\\=true\\]\\:text-default-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[active\\=true\\]\\:text-primary-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[active\\=true\\]\\:text-secondary-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[active\\=true\\]\\:text-success-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[active\\=true\\]\\:text-warning-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[disabled\\=true\\]\\:text-default-300[data-disabled="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-danger-300[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-300) / var(--heroui-danger-300-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-foreground-500[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-500) / var(--heroui-foreground-500-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-primary-300[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-300) / var(--heroui-primary-300-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-secondary-300[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-300) / var(--heroui-secondary-300-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-success-400[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-400) / var(--heroui-success-400-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-warning-400[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-400) / var(--heroui-warning-400-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:text-danger[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:text-foreground[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:text-primary[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:text-secondary[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:text-success-600[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:text-warning-600[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}

.data-\\[has-value\\=true\\]\\:text-default-foreground[data-has-value="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:\\!text-danger-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!text-primary-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!text-secondary-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!text-success-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:\\!text-warning-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity))) !important;
}

.data-\\[hover\\=true\\]\\:text-danger[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-danger-500[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-default-500[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-500) / var(--heroui-default-500-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-default-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-foreground-400[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-400) / var(--heroui-foreground-400-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-foreground-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-600) / var(--heroui-foreground-600-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-primary[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-primary-400[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-400) / var(--heroui-primary-400-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-primary-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-secondary[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-secondary-400[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-400) / var(--heroui-secondary-400-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-secondary-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-success[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-success-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-warning[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-warning-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}

.data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:text-danger[data-editable="true"][data-invalid="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[invalid\\=true\\]\\:text-danger-300[data-invalid="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-300) / var(--heroui-danger-300-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-background[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-primary-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-secondary-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:text-default-300[data-outside-month="true"][data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-500[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-foreground[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-600[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-500[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-500) / var(--heroui-warning-500-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-background[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-background[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-background[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-danger[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-danger-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-default-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-primary[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-primary-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-secondary[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-secondary-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-success-600[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-success-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-warning-600[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}

.data-\\[selected\\=true\\]\\:text-warning-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[unavailable\\=true\\]\\:text-default-300[data-unavailable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-300) / var(--heroui-default-300-opacity, var(--tw-text-opacity)));
}

.data-\\[unavailable\\=true\\]\\:line-through[data-unavailable="true"] {
  text-decoration-line: line-through;
}

.data-\\[animation\\=exiting\\]\\:opacity-0[data-animation="exiting"] {
  opacity: 0;
}

.data-\\[disabled\\=true\\]\\:data-\\[outside-month\\=true\\]\\:opacity-0[data-outside-month="true"][data-disabled="true"] {
  opacity: 0;
}

.data-\\[disabled\\=true\\]\\:opacity-30[data-disabled="true"] {
  opacity: 0.3;
}

.data-\\[hover-unselected\\=true\\]\\:opacity-disabled[data-hover-unselected="true"] {
  opacity: var(--heroui-disabled-opacity);
}

.data-\\[hover\\=true\\]\\:opacity-70[data-hover="true"] {
  opacity: 0.7;
}

.data-\\[hover\\=true\\]\\:opacity-hover[data-hover="true"] {
  opacity: var(--heroui-hover-opacity);
}

.data-\\[in-range\\=true\\]\\:opacity-100[data-in-range="true"] {
  opacity: 1;
}

.data-\\[invisible\\=true\\]\\:opacity-0[data-invisible="true"] {
  opacity: 0;
}

.data-\\[loaded\\=true\\]\\:opacity-100[data-loaded="true"] {
  opacity: 1;
}

.data-\\[moving\\]\\:opacity-100[data-moving] {
  opacity: 1;
}

.data-\\[pressed\\=true\\]\\:opacity-50[data-pressed="true"] {
  opacity: 0.5;
}

.data-\\[pressed\\=true\\]\\:opacity-70[data-pressed="true"] {
  opacity: 0.7;
}

.data-\\[pressed\\=true\\]\\:opacity-disabled[data-pressed="true"] {
  opacity: var(--heroui-disabled-opacity);
}

.data-\\[visible\\=true\\]\\:opacity-100[data-visible="true"] {
  opacity: 1;
}

.data-\\[active\\=true\\]\\:shadow-md[data-active="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[hover\\=true\\]\\:shadow-lg[data-hover="true"] {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:shadow-md[data-selection-end="true"][data-selected="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:shadow-md[data-selection-start="true"][data-selected="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[selected\\=true\\]\\:shadow-md[data-selected="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[selected\\=true\\]\\:shadow-none[data-selected="true"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[active\\=true\\]\\:shadow-danger\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[active\\=true\\]\\:shadow-default\\/50[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[active\\=true\\]\\:shadow-primary\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[active\\=true\\]\\:shadow-secondary\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[active\\=true\\]\\:shadow-success\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[active\\=true\\]\\:shadow-warning\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[hover\\=true\\]\\:shadow-danger\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[hover\\=true\\]\\:shadow-default\\/50[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[hover\\=true\\]\\:shadow-primary\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[hover\\=true\\]\\:shadow-secondary\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[hover\\=true\\]\\:shadow-success\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[hover\\=true\\]\\:shadow-warning\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selected\\=true\\]\\:shadow-danger\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selected\\=true\\]\\:shadow-foreground\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selected\\=true\\]\\:shadow-primary\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selected\\=true\\]\\:shadow-secondary\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selected\\=true\\]\\:shadow-success\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selected\\=true\\]\\:shadow-warning\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[focus-visible\\=true\\]\\:outline-2[data-focus-visible="true"] {
  outline-width: 2px;
}

.data-\\[focus-visible\\=true\\]\\:outline-offset-2[data-focus-visible="true"] {
  outline-offset: 2px;
}

.data-\\[focus-visible\\=true\\]\\:outline-focus[data-focus-visible="true"] {
  outline-color: hsl(var(--heroui-focus) / var(--heroui-focus-opacity, 1));
}

.data-\\[focus-visible\\]\\:outline-danger-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, 1));
}

.data-\\[focus-visible\\]\\:outline-default-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, 1));
}

.data-\\[focus-visible\\]\\:outline-primary-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, 1));
}

.data-\\[focus-visible\\]\\:outline-secondary-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, 1));
}

.data-\\[focus-visible\\]\\:outline-success-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, 1));
}

.data-\\[focus-visible\\]\\:outline-warning-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, 1));
}

.data-\\[menu-open\\=true\\]\\:backdrop-blur-xl[data-menu-open="true"] {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.data-\\[disabled\\=true\\]\\:transition-none[data-disabled="true"] {
  transition-property: none;
}

.data-\\[hover\\=true\\]\\:transition-colors[data-hover="true"] {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}

.data-\\[moving\\=true\\]\\:transition-transform[data-moving="true"] {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}

.data-\\[animation\\=exiting\\]\\:delay-100[data-animation="exiting"] {
  transition-delay: 100ms;
}

.data-\\[animation\\=exiting\\]\\:duration-200[data-animation="exiting"] {
  transition-duration: 200ms;
}

.data-\\[hide-scroll\\=true\\]\\:scrollbar-hide[data-hide-scroll="true"] {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.data-\\[hide-scroll\\=true\\]\\:scrollbar-hide[data-hide-scroll="true"]::-webkit-scrollbar {
  display: none;
}

.data-\\[top-bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-bottom-scroll="true"] {
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

.data-\\[top-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(0deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-scroll="true"] {
  mask-image: linear-gradient(0deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

.data-\\[bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(180deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-bottom-scroll="true"] {
  mask-image: linear-gradient(180deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

.data-\\[left-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(270deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-scroll="true"] {
  mask-image: linear-gradient(270deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

.data-\\[right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(90deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-right-scroll="true"] {
  mask-image: linear-gradient(90deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

.data-\\[left-right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(to_right\\2c \\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-right-scroll="true"] {
  mask-image: linear-gradient(to right,#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}

.data-\\[placement\\=bottom-end\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom-end"]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}

.data-\\[placement\\=bottom-end\\]\\:before\\:right-3[data-placement="bottom-end"]::before {
  content: var(--tw-content);
  right: 0.75rem;
}

.data-\\[placement\\=bottom-start\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom-start"]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}

.data-\\[placement\\=bottom-start\\]\\:before\\:left-3[data-placement="bottom-start"]::before {
  content: var(--tw-content);
  left: 0.75rem;
}

.data-\\[placement\\=bottom\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom"]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}

.data-\\[placement\\=bottom\\]\\:before\\:left-1\\/2[data-placement="bottom"]::before {
  content: var(--tw-content);
  left: 50%;
}

.data-\\[placement\\=left-end\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="left-end"]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}

.data-\\[placement\\=left-end\\]\\:before\\:bottom-1\\/4[data-placement="left-end"]::before {
  content: var(--tw-content);
  bottom: 25%;
}

.data-\\[placement\\=left-start\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="left-start"]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}

.data-\\[placement\\=left-start\\]\\:before\\:top-1\\/4[data-placement="left-start"]::before {
  content: var(--tw-content);
  top: 25%;
}

.data-\\[placement\\=left\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement="left"]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 2px) * -1);
}

.data-\\[placement\\=left\\]\\:before\\:top-1\\/2[data-placement="left"]::before {
  content: var(--tw-content);
  top: 50%;
}

.data-\\[placement\\=right-end\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="right-end"]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}

.data-\\[placement\\=right-end\\]\\:before\\:bottom-1\\/4[data-placement="right-end"]::before {
  content: var(--tw-content);
  bottom: 25%;
}

.data-\\[placement\\=right-start\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="right-start"]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}

.data-\\[placement\\=right-start\\]\\:before\\:top-1\\/4[data-placement="right-start"]::before {
  content: var(--tw-content);
  top: 25%;
}

.data-\\[placement\\=right\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement="right"]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 2px) * -1);
}

.data-\\[placement\\=right\\]\\:before\\:top-1\\/2[data-placement="right"]::before {
  content: var(--tw-content);
  top: 50%;
}

.data-\\[placement\\=top-end\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top-end"]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}

.data-\\[placement\\=top-end\\]\\:before\\:right-3[data-placement="top-end"]::before {
  content: var(--tw-content);
  right: 0.75rem;
}

.data-\\[placement\\=top-start\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top-start"]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}

.data-\\[placement\\=top-start\\]\\:before\\:left-3[data-placement="top-start"]::before {
  content: var(--tw-content);
  left: 0.75rem;
}

.data-\\[placement\\=top\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top"]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}

.data-\\[placement\\=top\\]\\:before\\:left-1\\/2[data-placement="top"]::before {
  content: var(--tw-content);
  left: 50%;
}

.data-\\[loaded\\=true\\]\\:before\\:-z-10[data-loaded="true"]::before {
  content: var(--tw-content);
  z-index: -10;
}

.data-\\[arrow\\=true\\]\\:before\\:block[data-arrow="true"]::before {
  content: var(--tw-content);
  display: block;
}

.data-\\[outside-month\\=true\\]\\:before\\:hidden[data-outside-month="true"]::before {
  content: var(--tw-content);
  display: none;
}

.data-\\[placement\\=bottom\\]\\:before\\:-translate-x-1\\/2[data-placement="bottom"]::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=left\\]\\:before\\:-translate-y-1\\/2[data-placement="left"]::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=right\\]\\:before\\:-translate-y-1\\/2[data-placement="right"]::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=top\\]\\:before\\:-translate-x-1\\/2[data-placement="top"]::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[loaded\\=true\\]\\:before\\:animate-none[data-loaded="true"]::before {
  content: var(--tw-content);
  animation: none;
}

.data-\\[range-end\\=true\\]\\:before\\:rounded-e-full[data-range-end="true"]::before {
  content: var(--tw-content);
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}

.data-\\[range-start\\=true\\]\\:before\\:rounded-s-full[data-range-start="true"]::before {
  content: var(--tw-content);
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}

.data-\\[selection-end\\=true\\]\\:before\\:rounded-e-full[data-selection-end="true"]::before {
  content: var(--tw-content);
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}

.data-\\[selection-start\\=true\\]\\:before\\:rounded-s-full[data-selection-start="true"]::before {
  content: var(--tw-content);
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-danger-50[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-foreground\\/10[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-foreground) / 0.1);
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-primary-50[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-secondary-50[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-success-100[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--heroui-success-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-warning-100[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[loaded\\=true\\]\\:before\\:opacity-0[data-loaded="true"]::before {
  content: var(--tw-content);
  opacity: 0;
}

.data-\\[selected\\=true\\]\\:before\\:opacity-100[data-selected="true"]::before {
  content: var(--tw-content);
  opacity: 1;
}

.data-\\[active\\=true\\]\\:after\\:w-full[data-active="true"]::after {
  content: var(--tw-content);
  width: 100%;
}

.data-\\[focus\\=true\\]\\:after\\:w-full[data-focus="true"]::after {
  content: var(--tw-content);
  width: 100%;
}

.data-\\[open\\=true\\]\\:after\\:w-full[data-open="true"]::after {
  content: var(--tw-content);
  width: 100%;
}

.data-\\[dragging\\=true\\]\\:after\\:scale-100[data-dragging="true"]::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[dragging\\=true\\]\\:after\\:scale-80[data-dragging="true"]::after {
  content: var(--tw-content);
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[active\\=true\\]\\:after\\:bg-danger-400[data-active="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-400) / var(--heroui-danger-400-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:after\\:bg-danger[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:after\\:bg-foreground[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:after\\:bg-primary[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:after\\:bg-secondary[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:after\\:bg-success[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[selected\\=true\\]\\:after\\:bg-warning[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[loaded\\=true\\]\\:after\\:opacity-0[data-loaded="true"]::after {
  content: var(--tw-content);
  opacity: 0;
}

.data-\\[selected\\=true\\]\\:after\\:opacity-100[data-selected="true"]::after {
  content: var(--tw-content);
  opacity: 1;
}

.data-\\[selectable\\=true\\]\\:focus\\:border-danger:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:border-default:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-border-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:border-primary:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:border-secondary:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:border-success:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:border-warning:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.data-\\[invalid\\=true\\]\\:focus\\:bg-danger-400\\/50:focus[data-invalid="true"] {
  background-color: hsl(var(--heroui-danger-400) / 0.5);
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-danger:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-danger\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-danger) / 0.2);
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-default:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-default-100:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-default\\/40:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-default) / 0.4);
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-primary:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-primary\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-primary) / 0.2);
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-secondary:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-secondary\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-secondary) / 0.2);
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-success:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-success\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-success) / 0.2);
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-warning:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:bg-warning\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-warning) / 0.2);
}

.data-\\[editable\\=true\\]\\:focus\\:text-danger:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-default-foreground:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-primary:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-secondary:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-success:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-success-600:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--heroui-success-600-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-warning:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.data-\\[editable\\=true\\]\\:focus\\:text-warning-600:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--heroui-warning-600-opacity, var(--tw-text-opacity)));
}

.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:focus\\:text-danger:focus[data-editable="true"][data-invalid="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-danger:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-danger-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-default-500:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-500) / var(--heroui-default-500-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-default-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-primary:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-primary-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-secondary:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-secondary-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-success:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-success-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-warning:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:text-warning-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.data-\\[selectable\\=true\\]\\:focus\\:shadow-danger\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selectable\\=true\\]\\:focus\\:shadow-default\\/50:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selectable\\=true\\]\\:focus\\:shadow-primary\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selectable\\=true\\]\\:focus\\:shadow-secondary\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selectable\\=true\\]\\:focus\\:shadow-success\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.data-\\[selectable\\=true\\]\\:focus\\:shadow-warning\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}

.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:start-0 {
  inset-inline-start: 0px;
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:start-0 {
  inset-inline-start: 0px;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:z-10 {
  z-index: 10;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-4 {
  margin-inline-start: 1rem;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-5 {
  margin-inline-start: 1.25rem;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-6 {
  margin-inline-start: 1.5rem;
}

.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-3 {
  margin-left: 0.75rem;
}

.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-4 {
  margin-left: 1rem;
}

.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-5 {
  margin-left: 1.25rem;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:block {
  display: block;
}

.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:block {
  display: block;
}

.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:flex {
  display: flex;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:hidden {
  display: none;
}

.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-5 {
  width: 1.25rem;
}

.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-6 {
  width: 1.5rem;
}

.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-7 {
  width: 1.75rem;
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_24px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_\\+_16px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_3\\.5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_4px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_24px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_\\+_16px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_3\\.5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_4px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:scale-85 {
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:scale-85 {
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/tr[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\/tr\\:cursor-not-allowed {
  cursor: not-allowed;
}

.group[data-has-multiple-months="true"] .group-data-\\[has-multiple-months\\=true\\]\\:flex-row {
  flex-direction: row;
}

.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:items-start {
  align-items: flex-start;
}

.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:items-end {
  align-items: flex-end;
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:\\!border-danger {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity))) !important;
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-default-foreground {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-border-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-primary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-secondary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-success {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-warning {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-default-500 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-500) / var(--heroui-default-500-opacity, var(--tw-border-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-primary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-border-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-secondary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-border-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-success {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-border-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-warning {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-border-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:\\!bg-danger-50 {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity))) !important;
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-default-200 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.group[data-hover-unselected="true"] .group-data-\\[hover-unselected\\=true\\]\\:bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-danger {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-default-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-400) / var(--heroui-default-400-opacity, var(--tw-bg-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-primary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-bg-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-secondary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-bg-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-success {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-warning {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-2 {
  padding-top: 0.5rem;
}

.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-3 {
  padding-top: 0.75rem;
}

.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-4 {
  padding-top: 1rem;
}

.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:pt-4 {
  padding-top: 1rem;
}

.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:pt-5 {
  padding-top: 1.25rem;
}

.group\\/tr[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\/tr\\:text-foreground-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-300) / var(--heroui-foreground-300-opacity, var(--tw-text-opacity)));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--heroui-default-600-opacity, var(--tw-text-opacity)));
}

.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--heroui-default-600-opacity, var(--tw-text-opacity)));
}

.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:text-danger {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-danger {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-danger-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--heroui-default-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--heroui-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-primary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--heroui-primary-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-primary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--heroui-primary-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-secondary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--heroui-secondary-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-secondary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--heroui-secondary-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-success {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-success-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-warning {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-warning-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:opacity-0 {
  opacity: 0;
}

.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:opacity-100 {
  opacity: 1;
}

.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:opacity-70 {
  opacity: 0.7;
}

.group\\/th[data-hover="true"] .group-data-\\[hover\\=true\\]\\/th\\:opacity-100 {
  opacity: 1;
}

.group[data-loaded="true"] .group-data-\\[loaded\\=true\\]\\:opacity-100 {
  opacity: 1;
}

.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:opacity-70 {
  opacity: 0.7;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-0 {
  opacity: 0;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-100 {
  opacity: 1;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-60 {
  opacity: 0.6;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-focus) / var(--heroui-focus-opacity, var(--tw-ring-opacity)));
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-2 {
  --tw-ring-offset-width: 2px;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-background {
  --tw-ring-offset-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, 1));
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:-z-10::before {
  content: var(--tw-content);
  z-index: -10;
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

.group[data-open="true"] .group-data-\\[open\\=true\\]\\:before\\:translate-y-px::before {
  content: var(--tw-content);
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-open="true"] .group-data-\\[open\\=true\\]\\:before\\:rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/tr[data-middle="true"] .group-data-\\[middle\\=true\\]\\/tr\\:before\\:rounded-none::before {
  content: var(--tw-content);
  border-radius: 0px;
}

.group[data-hover="true"] .group-data-\\[hover\\=true\\]\\:before\\:bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}

.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:ml-0\\.5::after {
  content: var(--tw-content);
  margin-left: 0.125rem;
}

.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}

.group[data-open="true"] .group-data-\\[open\\=true\\]\\:after\\:translate-y-0::after {
  content: var(--tw-content);
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-open="true"] .group-data-\\[open\\=true\\]\\:after\\:-rotate-45::after {
  content: var(--tw-content);
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:after\\:scale-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:after\\:bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:text-danger::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-text-opacity)));
}

.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:after\\:opacity-100::after {
  content: var(--tw-content);
  opacity: 1;
}

.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:content-\\[\\'\\*\\'\\]::after {
  --tw-content: '*';
  content: var(--tw-content);
}

.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:first\\:before\\:rounded-ss-lg:first-child::before {
  content: var(--tw-content);
  border-start-start-radius: 0.5rem;
}

.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:first\\:before\\:rounded-es-lg:first-child::before {
  content: var(--tw-content);
  border-end-start-radius: 0.5rem;
}

.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:last\\:before\\:rounded-se-lg:last-child::before {
  content: var(--tw-content);
  border-start-end-radius: 0.5rem;
}

.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:last\\:before\\:rounded-ee-lg:last-child::before {
  content: var(--tw-content);
  border-end-end-radius: 0.5rem;
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:hover\\:border-danger:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:hover\\:bg-danger-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-bg-opacity)));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:border-danger:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-border-opacity)));
}

.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:bg-danger-50:hover:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.group\\/tr[aria-selected="false"][data-hover="true"] .group-aria-\\[selected\\=false\\]\\/tr\\:group-data-\\[hover\\=true\\]\\/tr\\:before\\:bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.group\\/tr[aria-selected="false"][data-hover="true"] .group-aria-\\[selected\\=false\\]\\/tr\\:group-data-\\[hover\\=true\\]\\/tr\\:before\\:opacity-70::before {
  content: var(--tw-content);
  opacity: 0.7;
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-danger\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-danger) / 0.2);
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-default\\/60[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-default) / 0.6);
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-primary\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-primary) / 0.2);
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-secondary\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-secondary) / 0.2);
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-success\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-success) / 0.2);
}

.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-warning\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-warning) / 0.2);
}

.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}

.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:block {
  display: block;
}

.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:opacity-70 {
  opacity: 0.7;
}

@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .motion-reduce\\:transition-none {
    transition-property: none;
  }

  .motion-reduce\\:after\\:transition-none::after {
    content: var(--tw-content);
    transition-property: none;
  }
}

.dark\\:border-danger-100:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-border-opacity)));
}

.dark\\:border-default-200:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-border-opacity)));
}

.dark\\:border-primary-100:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-100) / var(--heroui-primary-100-opacity, var(--tw-border-opacity)));
}

.dark\\:border-success-100:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-100) / var(--heroui-success-100-opacity, var(--tw-border-opacity)));
}

.dark\\:border-warning-100:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-border-opacity)));
}

.dark\\:bg-amber-900\\/20:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}

.dark\\:bg-background:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-background) / var(--heroui-background-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-background\\/20:is(.dark *) {
  background-color: hsl(var(--heroui-background) / 0.2);
}

.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:bg-content2:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content2) / var(--heroui-content2-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-danger-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--heroui-danger-100-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-danger-50:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-danger-50\\/50:is(.dark *) {
  background-color: hsl(var(--heroui-danger-50) / 0.5);
}

.dark\\:bg-default:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--heroui-default-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-default-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-default-50\\/50:is(.dark *) {
  background-color: hsl(var(--heroui-default-50) / 0.5);
}

.dark\\:bg-green-900\\/20:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:bg-primary-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-100) / var(--heroui-primary-100-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-primary-50:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--heroui-primary-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-primary-50\\/50:is(.dark *) {
  background-color: hsl(var(--heroui-primary-50) / 0.5);
}

.dark\\:bg-purple-900\\/20:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}

.dark\\:bg-secondary-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-100) / var(--heroui-secondary-100-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-secondary-50:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--heroui-secondary-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-secondary-50\\/50:is(.dark *) {
  background-color: hsl(var(--heroui-secondary-50) / 0.5);
}

.dark\\:bg-success-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--heroui-success-100-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-success-50:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-success-50\\/50:is(.dark *) {
  background-color: hsl(var(--heroui-success-50) / 0.5);
}

.dark\\:bg-transparent:is(.dark *) {
  background-color: transparent;
}

.dark\\:bg-warning-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--heroui-warning-100-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-warning-50:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:bg-warning-50\\/50:is(.dark *) {
  background-color: hsl(var(--heroui-warning-50) / 0.5);
}

.dark\\:text-danger-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-success:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.dark\\:text-warning:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.dark\\:placeholder\\:text-danger-500:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}

.dark\\:placeholder\\:text-success:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.dark\\:placeholder\\:text-warning:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.dark\\:before\\:via-default-700\\/10:is(.dark *)::before {
  content: var(--tw-content);
  --tw-gradient-to: hsl(var(--heroui-default-700) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-default-700) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:after\\:bg-content2:is(.dark *)::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content2) / var(--heroui-content2-opacity, var(--tw-bg-opacity)));
}

.dark\\:focus\\:bg-danger-400\\/20:focus:is(.dark *) {
  background-color: hsl(var(--heroui-danger-400) / 0.2);
}

.dark\\:focus\\:bg-success-400\\/20:focus:is(.dark *) {
  background-color: hsl(var(--heroui-success-400) / 0.2);
}

.dark\\:focus\\:bg-warning-400\\/20:focus:is(.dark *) {
  background-color: hsl(var(--heroui-warning-400) / 0.2);
}

.dark\\:data-\\[hover\\=true\\]\\:bg-content2[data-hover="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content2) / var(--heroui-content2-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[hover\\=true\\]\\:bg-danger-50[data-hover="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--heroui-danger-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[hover\\=true\\]\\:bg-success-50[data-hover="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[hover\\=true\\]\\:bg-warning-50[data-hover="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"][data-selected="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--heroui-danger-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-success[data-hover="true"][data-selected="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"][data-selected="true"]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[hover\\=true\\]\\:text-danger-500[data-hover="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[hover\\=true\\]\\:text-success-500[data-hover="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-500) / var(--heroui-success-500-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[hover\\=true\\]\\:text-warning-500[data-hover="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-500) / var(--heroui-warning-500-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"][data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--heroui-danger-foreground-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"][data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"][data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--heroui-warning-foreground-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-500[data-range-selection="true"][data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-500) / var(--heroui-success-500-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--heroui-success-foreground-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:text-danger-500[data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--heroui-danger-500-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:text-success[data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--heroui-success-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:text-warning[data-selected="true"]:is(.dark *) {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--heroui-warning-opacity, var(--tw-text-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-success-50[data-range-selection="true"][data-selected="true"]:is(.dark *)::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--heroui-success-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-warning-50[data-range-selection="true"][data-selected="true"]:is(.dark *)::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--heroui-warning-50-opacity, var(--tw-bg-opacity)));
}

.dark\\:data-\\[invalid\\=true\\]\\:focus\\:bg-danger-400\\/20:focus[data-invalid="true"]:is(.dark *) {
  background-color: hsl(var(--heroui-danger-400) / 0.2);
}

@media (min-width: 640px) {

  .sm\\:m-0 {
    margin: 0px;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .sm\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .sm\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .sm\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:w-\\[356px\\] {
    width: 356px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:\\[--scale-enter\\:100\\%\\] {
    --scale-enter: 100%;
  }

  .sm\\:\\[--scale-exit\\:103\\%\\] {
    --scale-exit: 103%;
  }

  .sm\\:\\[--slide-enter\\:0px\\] {
    --slide-enter: 0px;
  }

  .sm\\:\\[--slide-exit\\:0px\\] {
    --slide-exit: 0px;
  }

  .sm\\:data-\\[visible\\=true\\]\\:pointer-events-none[data-visible="true"] {
    pointer-events: none;
  }

  .sm\\:data-\\[placement\\=bottom-center\\]\\:mx-auto[data-placement="bottom-center"] {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:data-\\[placement\\=top-center\\]\\:mx-auto[data-placement="top-center"] {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:data-\\[placement\\=bottom-left\\]\\:ml-2[data-placement="bottom-left"] {
    margin-left: 0.5rem;
  }

  .sm\\:data-\\[placement\\=bottom-right\\]\\:mr-2[data-placement="bottom-right"] {
    margin-right: 0.5rem;
  }

  .sm\\:data-\\[placement\\=top-left\\]\\:ml-2[data-placement="top-left"] {
    margin-left: 0.5rem;
  }

  .sm\\:data-\\[placement\\=top-right\\]\\:mr-2[data-placement="top-right"] {
    margin-right: 0.5rem;
  }

  .sm\\:data-\\[placement\\=bottom-center\\]\\:w-max[data-placement="bottom-center"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=bottom-left\\]\\:w-max[data-placement="bottom-left"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=bottom-right\\]\\:w-max[data-placement="bottom-right"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=top-center\\]\\:w-max[data-placement="top-center"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=top-left\\]\\:w-max[data-placement="top-left"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=top-right\\]\\:w-max[data-placement="top-right"] {
    width: max-content;
  }

  .sm\\:data-\\[visible\\=true\\]\\:opacity-0[data-visible="true"] {
    opacity: 0;
  }

  .group[data-hover="true"] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:pointer-events-auto[data-visible="true"] {
    pointer-events: auto;
  }

  .group[data-hover="true"] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:opacity-100[data-visible="true"] {
    opacity: 1;
  }
}

@media (min-width: 768px) {

  .md\\:-left-12 {
    left: -3rem;
  }

  .md\\:-right-12 {
    right: -3rem;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-72 {
    height: 18rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:aspect-\\[4\\/3\\] {
    aspect-ratio: 4/3;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:aspect-\\[16\\/9\\] {
    aspect-ratio: 16/9;
  }
}

.rtl\\:left-2:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.5rem;
}

.rtl\\:right-auto:where([dir="rtl"], [dir="rtl"] *) {
  right: auto;
}

.rtl\\:origin-top-right:where([dir="rtl"], [dir="rtl"] *) {
  transform-origin: top right;
}

.rtl\\:-rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row-reverse;
}

.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}

.rtl\\:data-\\[focus-visible\\=true\\]\\:translate-x-3[data-focus-visible="true"]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:data-\\[hover\\=true\\]\\:translate-x-3[data-hover="true"]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:data-\\[open\\=true\\]\\:-rotate-90[data-open="true"]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\+\\.border-medium\\.border-danger\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-danger {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}

.\\[\\&\\+\\.border-medium\\.border-default\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-default {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}

.\\[\\&\\+\\.border-medium\\.border-primary\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-primary {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}

.\\[\\&\\+\\.border-medium\\.border-secondary\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-secondary {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}

.\\[\\&\\+\\.border-medium\\.border-success\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-success {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}

.\\[\\&\\+\\.border-medium\\.border-warning\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-warning {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}

.\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\]\\:rounded-none:not(:first-child):not(:last-child) {
  border-radius: 0px;
}

.\\[\\&\\:not\\(\\:first-child\\)\\]\\:-ml-1:not(:first-child) {
  margin-left: -0.25rem;
}

.\\[\\&\\:not\\(\\:first-of-type\\)\\:not\\(\\:last-of-type\\)\\]\\:rounded-none:not(:first-of-type):not(:last-of-type) {
  border-radius: 0px;
}

.\\[\\&\\:not\\(\\:first-of-type\\)\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.2\\)\\*-1\\)\\]:not(:first-of-type) {
  margin-inline-start: calc(2px * -1);
}

.\\[\\&\\>\\*\\]\\:relative>* {
  position: relative;
}

.\\[\\&\\>svg\\]\\:max-w-\\[theme\\(spacing\\.8\\)\\]>svg {
  max-width: 2rem;
}

.\\[\\&\\>tr\\]\\:first\\:rounded-lg:first-child>tr {
  border-radius: 0.5rem;
}

.\\[\\&\\>tr\\]\\:first\\:shadow-small:first-child>tr {
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:bg-default-100[data-hover=true]:not([data-active=true]) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--heroui-default-100-opacity, var(--tw-bg-opacity)));
}

.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:bg-default-200[data-hover=true]:not([data-active=true]) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--heroui-default-200-opacity, var(--tw-bg-opacity)));
}

.\\[\\&_\\.chevron-icon\\]\\:flex-none .chevron-icon {
  flex: none;
}

.\\[\\&_\\.chevron-icon\\]\\:rotate-180 .chevron-icon {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\.chevron-icon\\]\\:transition-transform .chevron-icon {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,oCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,aAAmB;IAAnB,2BAAmB;IAAnB,kCAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,YAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wHAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kHAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,sFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,8BAAmB;EAAnB,mCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,oDAAmB;EAAnB,4BAAmB;EAAnB,8BAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,4BAAmB;EAAnB,6DAAmB;EAAnB,mCAAmB;EAAnB,6CAAmB;EAAnB,gCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,6CAAmB;EAAnB,gCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,mCAAmB;EAAnB,oCAAmB;EAAnB,kCAAmB;EAAnB,uCAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,mDAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,mDAAmB;EAAnB,mDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,oCAAmB;EAAnB,sCAAmB;EAAnB,iDAAmB;EAAnB,wCAAmB;EAAnB,mCAAmB;EAAnB,qDAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,kIAAmB;EAAnB,oIAAmB;EAAnB,oIAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4BAAmB;EAAnB,qCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oCAAmB;EAAnB,qCAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,8BAAmB;EAAnB,gCAAmB;EAAnB,yCAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,2CAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,kCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,iCAAmB;EAAnB,sCAAmB;EAAnB,kCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,sDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,kDAAmB;EAAnB,mDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,qDAAmB;EAAnB,mCAAmB;EAAnB,wCAAmB;EAAnB,iDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,8IAAmB;EAAnB,iJAAmB;EAAnB,iJAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wGAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+HAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,mBAAmB;;AAGnB,iDAAiD;AACjD;EACE,2BAA2B;AAC7B;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,2BAA2B;AAEzB;EAAA,iBAAkE;EAAlE,sBAAkE;EAAlE,0GAAkE;EAAlE,qDAAkE;EAAlE,8BAAkE;EAAlE;AAAkE;;AAGpE,0BAA0B;AAC1B;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,iEAAiE;AACnE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AApGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,uBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;;EAAA;IAAA,0BAqGA;IArGA;EAqGA;AAAA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,gEAqGA;EArGA,+DAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iFAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,2CAqGA;EArGA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,+FAqGA;EArGA,wDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,8BAqGA;EArGA,wDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,gBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,0BAqGA;EArGA,gCAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,yBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,gBAqGA;EArGA,gBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,yCAqGA;EArGA,uDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,2CAqGA;EArGA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,wBAqGA;EArGA,wDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,8BAqGA;EArGA,wDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,gBAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,+BAqGA;EArGA,gCAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,0BAqGA;EArGA,gCAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,2BAqGA;EArGA,gCAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,uCAqGA;EArGA,gCAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,iCAqGA;EArGA;AAqGA;;AArGA;EAAA,qDAqGA;EArGA;AAqGA;;AArGA;EAAA,iCAqGA;EArGA;AAqGA;;AArGA;EAAA,sDAqGA;EArGA;AAqGA;;AArGA;EAAA,8BAqGA;EArGA;AAqGA;;AArGA;EAAA,qDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iCAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,oDAqGA;EArGA;AAqGA;;AArGA;EAAA,4BAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,4BAqGA;EArGA;AAqGA;;AArGA;EAAA,8BAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,0CAqGA;EArGA,uDAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,8BAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,qBAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,uBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,uBAqGA;EArGA;AAqGA;;AArGA;EAAA,uBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,qBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,6EAqGA;EArGA,iGAqGA;EArGA;AAqGA;;AArGA;EAAA,+EAqGA;EArGA,mGAqGA;EArGA;AAqGA;;AArGA;EAAA,6EAqGA;EArGA,iGAqGA;EArGA;AAqGA;;AArGA;EAAA,6EAqGA;EArGA,iGAqGA;EArGA;AAqGA;;AArGA;EAAA,6EAqGA;EArGA,iGAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA,8BAqGA;EArGA;AAqGA;;AArGA;EAAA,kDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,qDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,kDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,qDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,kDAqGA;EArGA;AAqGA;;AArGA;EAAA,sDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,qDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,8BAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,+FAqGA;EArGA,wDAqGA;EArGA;AAqGA;;AArGA;EAAA,8BAqGA;EArGA,wDAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,wBAqGA;EArGA,qBAqGA;AAAA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iCAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,+BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iCAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,iBAqGA;EArGA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,kDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,qDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kFAqGA;EArGA;AAqGA;;AArGA;EAAA,kFAqGA;EArGA;AAqGA;;AArGA;EAAA,iFAqGA;EArGA;AAqGA;;AArGA;EAAA,kFAqGA;EArGA;AAqGA;;AArGA;EAAA,gFAqGA;EArGA;AAqGA;;AArGA;EAAA,gFAqGA;EArGA;AAqGA;;AArGA;EAAA,oHAqGA;EArGA;AAqGA;;AArGA;EAAA,gFAqGA;EArGA;AAqGA;;AArGA;EAAA,oHAqGA;EArGA;AAqGA;;AArGA;EAAA,+EAqGA;EArGA;AAqGA;;AArGA;EAAA,+EAqGA;EArGA;AAqGA;;AArGA;EAAA,mHAqGA;EArGA;AAqGA;;AArGA;EAAA,kFAqGA;EArGA;AAqGA;;AArGA;EAAA,kFAqGA;EArGA;AAqGA;;AArGA;EAAA,iFAqGA;EArGA;AAqGA;;AArGA;EAAA,kFAqGA;EArGA;AAqGA;;AArGA;EAAA,gFAqGA;EArGA;AAqGA;;AArGA;EAAA,gFAqGA;EArGA;AAqGA;;AArGA;EAAA,oHAqGA;EArGA;AAqGA;;AArGA;EAAA,gFAqGA;EArGA;AAqGA;;AArGA;EAAA,oHAqGA;EArGA;AAqGA;;AArGA;EAAA,+EAqGA;EArGA;AAqGA;;AArGA;EAAA,+EAqGA;EArGA;AAqGA;;AArGA;EAAA,mHAqGA;EArGA;AAqGA;;AArGA;EAAA,yBAqGA;EArGA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,gBAqGA;EArGA,gBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,iCAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,6BAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,2GAqGA;EArGA,yGAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,qBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,qBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,iBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,eAqGA;EArGA,eAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;;EAAA;IAAA,eAqGA;IArGA,eAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,0BAqGA;IArGA;EAqGA;AAAA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA,sBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,oFAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,0BAqGA;EArGA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;;EAAA;IAAA;EAqGA;;EArGA;IAAA,gBAqGA;IArGA;EAqGA;;EArGA;IAAA,oBAqGA;IArGA;EAqGA;;EArGA;IAAA,mBAqGA;IArGA;EAqGA;;EArGA;IAAA,eAqGA;IArGA;EAqGA;;EArGA;IAAA,gBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,iBAqGA;IArGA;EAqGA;;EArGA;IAAA,oBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,iBAqGA;IArGA;EAqGA;;EArGA;IAAA,iBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;AAAA;;AArGA;;EAAA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,gBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,kBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,iBAqGA;IArGA;EAqGA;;EArGA;IAAA,mBAqGA;IArGA;EAqGA;;EArGA;IAAA,kBAqGA;IArGA;EAqGA;;EArGA;IAAA,eAqGA;IArGA;EAqGA;AAAA;;AArGA;;EAAA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,gBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,kBAqGA;IArGA;EAqGA;;EArGA;IAAA;EAqGA;;EArGA;IAAA,kBAqGA;IArGA;EAqGA;AAAA;;AArGA;;EAAA;IAAA;EAqGA;AAAA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,oBAqGA;EArGA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,yBAqGA;EArGA;AAqGA;;AArGA;EAAA,yBAqGA;EArGA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,2CAqGA;EArGA,mDAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA,kBAqGA;EArGA;AAqGA;;AArGA;EAAA;AAqGA;;AArGA;EAAA,mBAqGA;EArGA;AAqGA;;AArGA;EAAA,8BAqGA;EArGA,wDAqGA;EArGA;AAqGA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Globalne style */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* Theme transitions for smooth theme switching */\n:root {\n  --transition-duration: 0.5s;\n}\n\nhtml {\n  transition: color var(--transition-duration), background-color var(--transition-duration);\n}\n\nhtml.dark {\n  color-scheme: dark;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  scroll-behavior: smooth;\n}\n\n/* Animacje */\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n/* Klasy pomocnicze do animacji */\n.animate-float {\n  animation: float 6s ease-in-out infinite;\n}\n\n.animate-pulse-slow {\n  animation: pulse 4s ease-in-out infinite;\n}\n\n.animate-gradient {\n  background-size: 400% 400%;\n  animation: gradient 15s ease infinite;\n}\n\n/* Dodatkowe style dla przycisków animowanych */\n.btn-animated:hover {\n  transform: translateY(-3px);\n  transition: transform 0.3s ease;\n}\n\n/* Klasa dla efektu szkła */\n.glass-effect {\n  @apply backdrop-blur-md bg-background/60 border border-default-200;\n}\n\n/* Efekty hover dla kart */\n.card-hover-effect {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card-hover-effect:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 12px 30px -10px rgba(var(--color-primary-500), 0.3);\n}\n\n.badge-logo {\n  margin-top: 12px;\n  margin-right: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
